<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX1+M2KR5YBHYRRqUeyUlmE5O5UxZUwDBEQE=",
          "cpf": "U2FsdGVkX18Qp+bnM1vNehhs3zLLPUv3FwdJ1bSpSJY="
        }, {
          "num_cand": "U2FsdGVkX1/ox4cUi5fNGjok15Y3aEYePvZbZ0f9ZCs=",
          "cpf": "U2FsdGVkX1/WghAXXf5KjWW6N6MPh2EhcXvKC5Kiss0="
        }, {
          "num_cand": "U2FsdGVkX1/ZMHCqvuwnjyR05nmpOSqPykfd1LvguaM=",
          "cpf": "U2FsdGVkX197wNzNbrFdwARGUJ8PUUiGWXDqPPEgbiI="
        }, {
          "num_cand": "U2FsdGVkX19L983SJOvAKxpKCC3cSGR4vK/kaKaFfa0=",
          "cpf": "U2FsdGVkX1+FFdQ21LKCO16FETKZ/XDteZAnMSoCHCw="
        }, {
          "num_cand": "U2FsdGVkX18d8eIR2zWUawexbUxZeLQU4lQk7aHiMOM=",
          "cpf": "U2FsdGVkX19/WR5JTIaU5R+KdA3NchgGirLtKZaeB/c="
        }, {
          "num_cand": "U2FsdGVkX1/kyvIQWsWYN9h4bR4zYcVTJwbmJW62HsE=",
          "cpf": "U2FsdGVkX186dwT+AkBy1piwt61E51WmVHnPvn0awiQ="
        }, {
          "num_cand": "U2FsdGVkX18rjt4Ju33mFkSDjVNohD8xFmLwAFhIUus=",
          "cpf": "U2FsdGVkX19DXg8Nkt8bfTWZixkeUCwTC6hp6Dzg3LI="
        }, {
          "num_cand": "U2FsdGVkX19wxyim6xWtTHEdTE6jvyzE45+98t8gb/c=",
          "cpf": "U2FsdGVkX19ZaTLGX9HinSEiXbgMXbc1gsvh6jPLu4s="
        }, {
          "num_cand": "U2FsdGVkX18V9NrJWJcKb4n+DBu13pUl8MN34CDcJcs=",
          "cpf": "U2FsdGVkX1+gDHePxSXdfGCRcWecDIOjdxDe+6Skl5M="
        }, {
          "num_cand": "U2FsdGVkX1/xCHyH8TZOxLYE11vQl9SdViuGnTIkMA0=",
          "cpf": "U2FsdGVkX18nenkS2hCgmHLQ5iDjZAqwxrDi15kUrh8="
        }, {
          "num_cand": "U2FsdGVkX182+oklfyTjkql1I0KeayBsmBB22NbACCM=",
          "cpf": "U2FsdGVkX19LfLRJTg1oDzfZsYWo0Pnl6AdpTjTcq1I="
        }, {
          "num_cand": "U2FsdGVkX1/CWeP1kiYco1nxVoKwThaoC8BlT4vLBoc=",
          "cpf": "U2FsdGVkX1+FWRrmeUUOXZ9n/CnA/sWVlgD/vHumJCQ="
        }, {
          "num_cand": "U2FsdGVkX18JFsS0UqGzhe4WHJHNT7cT5AZfV1uvkn8=",
          "cpf": "U2FsdGVkX1+HqqrMPc6yR0PQ7hppRmmfzVdQoCSjWE4="
        }, {
          "num_cand": "U2FsdGVkX19YgSvH5K5CLdhRXrL20K6i/2JlZm/5PKw=",
          "cpf": "U2FsdGVkX18KKBsSK9ufFkvg3gM7nGZT6mAHfEDKfDY="
        }, {
          "num_cand": "U2FsdGVkX1/f6dF5Wjx63qyVd5yYRAXQPKoSBDr3qE0=",
          "cpf": "U2FsdGVkX18UThAiNzL76I717qIrC7I6qjJ64wpMIQ4="
        }, {
          "num_cand": "U2FsdGVkX1+QHAjUIpNoPBfkOZnSdFQ7sbOoGJDe4dc=",
          "cpf": "U2FsdGVkX18hSqFEQk9LfdXqEIchhFx5rE9NDNG5a0s="
        }, {
          "num_cand": "U2FsdGVkX1+VvrBsgNHNM2qsoiB/PLBQhRsQS0gnzjw=",
          "cpf": "U2FsdGVkX1/xnClDa3VqX2HNy0TiHqOjrAWisLNhGe8="
        }, {
          "num_cand": "U2FsdGVkX19NP4Y6JxgRiBEKsBU3EAf5qWABLB3f9FU=",
          "cpf": "U2FsdGVkX1/0oOpWRQUlXE7K2r5w5GqII/JauIoDIaA="
        }, {
          "num_cand": "U2FsdGVkX188Wf+6J5OOjpvE9DKAGSlXMRpfoPhWyh8=",
          "cpf": "U2FsdGVkX19j7YtJXI08F1Q5vLdzLGB1Dx5iXDGtfjE="
        }, {
          "num_cand": "U2FsdGVkX197AZiJg7tY9682UYuiwIQfXJrkc4nRF6s=",
          "cpf": "U2FsdGVkX1/RV1buBKefd04cH6DhjHly3FjMrH+2JZY="
        }, {
          "num_cand": "U2FsdGVkX19KLTB38Y7+0F3X3kz425yiR7oFHYj3EZY=",
          "cpf": "U2FsdGVkX199S0OxHnUEatkfPM0/Thv0HZsuFy3PJa0="
        }, {
          "num_cand": "U2FsdGVkX1//kG2JcMOY6kny2R3yXD7bbyCRVnKLdzw=",
          "cpf": "U2FsdGVkX18OdxXOaS50Cy+AGJz3IkpTDioBfKyt2jA="
        }, {
          "num_cand": "U2FsdGVkX19NuFriklHvaKlUlOwKRStfUEmO/ahQt/Q=",
          "cpf": "U2FsdGVkX1+FQl9EP8TLdThDKE0MVzpCfs/NZ2GAI5M="
        }, {
          "num_cand": "U2FsdGVkX18Xr0TFfeo0ErxmN60vrjDFCx8HOcnWqhY=",
          "cpf": "U2FsdGVkX18mwlc7/hIzNT601sSWD9qc9mqM9xZiciE="
        }, {
          "num_cand": "U2FsdGVkX18W5DfqEzErd5MLVegUjGAVzOR4T4Wxs7U=",
          "cpf": "U2FsdGVkX1/GmLgTJQEKcw7ANvacDORUUFRbfBjk12w="
        }, {
          "num_cand": "U2FsdGVkX19X+GRzvMrYBCan42L1fYHzOE2i9SjE1tk=",
          "cpf": "U2FsdGVkX1+uxRnPt2ksyodYDyLoiI+LbIM5t5fbSHw="
        }, {
          "num_cand": "U2FsdGVkX1+z3D4SvR2K8/CbLB8zZRpwoi6n8FkXUuE=",
          "cpf": "U2FsdGVkX1+Me1JrQxZdreCUxojTzD2ildgSZG/uPVg="
        }, {
          "num_cand": "U2FsdGVkX18MrkIF3rEAiycFxV/IEV7G3hUP7qvJs7g=",
          "cpf": "U2FsdGVkX1/9SgBntYyx8/Vl92Pp/MPcTd2HWT01p/4="
        }, {
          "num_cand": "U2FsdGVkX1849q4B9mCdrHjqtBT8iNYoYU2wa1pyqXo=",
          "cpf": "U2FsdGVkX19mL8u4JZLXNZ/ZI9CAvGGzwtkMJZDtfx0="
        }, {
          "num_cand": "U2FsdGVkX18vUUVy1YwRiP3Bz3VC5ttNvZ1hWiXUtL4=",
          "cpf": "U2FsdGVkX1/1rPjmSsq4WR/jWv5d6wCho89HnrzUekY="
        }, {
          "num_cand": "U2FsdGVkX1/J5DzkCT5o7aizHbtXMy34eI6wegnoCDs=",
          "cpf": "U2FsdGVkX19qhd07cUk8NRqtudBK2HjJpGVWNYw1/fQ="
        }, {
          "num_cand": "U2FsdGVkX18Cn3ZNRFBC9Y3zFenhbpsZ51AsqpV0Ukk=",
          "cpf": "U2FsdGVkX19aLVU2DOjVavPnQDZyMTVd6LhwsOhkQzk="
        }, {
          "num_cand": "U2FsdGVkX1/d0vnbvAeQG1b11w4E5phENaH1oDnkEJE=",
          "cpf": "U2FsdGVkX195/RK+8ohxQnvRGkJjpoTNx6XzJoFf87w="
        }, {
          "num_cand": "U2FsdGVkX18mWBD0x/ycKusEig2CTNYlqn7ti4WEjEo=",
          "cpf": "U2FsdGVkX1/R8OpklFa0ezuXUMLwspeuBfS+qprbJMk="
        }, {
          "num_cand": "U2FsdGVkX18fevN8SWh+qF9OmZ2rnWp9QirwCpERQxo=",
          "cpf": "U2FsdGVkX1+m9n1e3FYBJdXIdRJXZdlk7gnbWY+ssi4="
        }, {
          "num_cand": "U2FsdGVkX18pEI2dMGo/clIPagL8HGAlyxG5f+/OeP4=",
          "cpf": "U2FsdGVkX1/XE3twRWvQM5vZxUe9FqZnXNk50yup7sA="
        }, {
          "num_cand": "U2FsdGVkX1/l5vEIaif/HqE8xkckmBCGHnT2Ums4WGw=",
          "cpf": "U2FsdGVkX191p6btIIfP0AXK0WzJxWg6l0pA1TDer6k="
        }, {
          "num_cand": "U2FsdGVkX1/fkD+k5UUuIbV1Man+/wuRo9PHWoc5pek=",
          "cpf": "U2FsdGVkX1+gfya9ecLQa8YmRZxaXEP3UyzUnMeXgZo="
        }, {
          "num_cand": "U2FsdGVkX1++6cmC4FqqEsW8VWG1AB9kTnvwsa+s/oI=",
          "cpf": "U2FsdGVkX18ZwE0oSp2KzbUBJp2TLoBvDt6fHFp6U1U="
        }, {
          "num_cand": "U2FsdGVkX19TIuAL7yKKTL0k0P+dvMSFk0OEap6NZqE=",
          "cpf": "U2FsdGVkX1/v0sRx4WRwPPkz2HXtmpyATrwP3dZ/8YM="
        }, {
          "num_cand": "U2FsdGVkX1+8QHq4A1kovU4QbABTpzlNGtesCTort00=",
          "cpf": "U2FsdGVkX18/vixvtG2lxhelThILyOAIR1XUjZ6wLXo="
        }, {
          "num_cand": "U2FsdGVkX19e+tUzn/YiieQ0vWWNZU7eK0sYJySrR9M=",
          "cpf": "U2FsdGVkX190D29FIwvI/FqXtqWyM8bJzpInyjESS1Y="
        }, {
          "num_cand": "U2FsdGVkX19w1fW/mpPTtKUTNxJerlqiaPdYzJHQ9Jo=",
          "cpf": "U2FsdGVkX19EcBGctPtCQ2bzkxWLsw2/Uh2p6iv/4WI="
        }, {
          "num_cand": "U2FsdGVkX19SkIyKPEC1tA+iRq9JDSfr5JtpySIn7Ps=",
          "cpf": "U2FsdGVkX18k/ie2Wa2VNm3yy/h7TT6nNVYIOBkZm7s="
        }, {
          "num_cand": "U2FsdGVkX18j/jGPscX1+JEE8NeCJJQlErkKIUlbLkg=",
          "cpf": "U2FsdGVkX18um3pWQlHyPLE9z8Xxbvco4tqFKRuPVT8="
        }, {
          "num_cand": "U2FsdGVkX18Afpu/aAJjSSaRzB/5GOpM8PstkyRCkls=",
          "cpf": "U2FsdGVkX1/vQCdloFrNZJ3nMjys025Qs3NU39L40Ec="
        }, {
          "num_cand": "U2FsdGVkX1989LW0OXKSJFejvekXxmbNDc80CkxugP0=",
          "cpf": "U2FsdGVkX19BNTBTLP0sNQVsHWEFnH7uLCRMKjH9KE0="
        }, {
          "num_cand": "U2FsdGVkX1+FD3kMp4Z1TVx5zomx4y+c3tXukXPXjvA=",
          "cpf": "U2FsdGVkX19iyvWkgCmW4I27IFYEO6/H/jch05OxcE0="
        }, {
          "num_cand": "U2FsdGVkX196PVtB0hsvt6V4xlM93YQg5r3m2JTLa2A=",
          "cpf": "U2FsdGVkX18OEiNVGxnovBKmqApLFfadPrOG5335YxI="
        }, {
          "num_cand": "U2FsdGVkX1/YGvaKZXiZobNgKUFv0Wiub65Ae7eAe3k=",
          "cpf": "U2FsdGVkX1/A36rZ3oqdw8hM5tiQFoWTs12qoAN8LGE="
        }, {
          "num_cand": "U2FsdGVkX1+bp1mOGld12Q4UB/KuPgFgYvq7XHBJNbY=",
          "cpf": "U2FsdGVkX18dUt4Izj5YKt6pxPOXc8yXK7geI+Gh+zw="
        }, {
          "num_cand": "U2FsdGVkX19mRaWOtwnsaTqUzieHUXndjUd+J7EOrpk=",
          "cpf": "U2FsdGVkX1/ubgdeQMe0FedQ0H3Ymjzph5y3hGdLDyU="
        }, {
          "num_cand": "U2FsdGVkX19MFutE+M09fcB5VDtUJjSsuVYmxOn3J3c=",
          "cpf": "U2FsdGVkX1/YeABWw+quB4nkjWsSh7QDxfDexWsQ7nk="
        }, {
          "num_cand": "U2FsdGVkX1/C+PwLmh7sEPLMHc+HSSRHNL6MLOq3GiI=",
          "cpf": "U2FsdGVkX1+xIEdfa9l8vZH5iuXm9VkgQXLTZvs+k9k="
        }, {
          "num_cand": "U2FsdGVkX18p4pi8OhtyxeIaKUSr0WFpNkRlgv185s4=",
          "cpf": "U2FsdGVkX1/Xjmap57vjq7FSatwRgYMXnqw3PVCEGks="
        }, {
          "num_cand": "U2FsdGVkX19OgJC+6FGcIQLFHKeE3vqSf6BsQS8015U=",
          "cpf": "U2FsdGVkX1+bj3Erb9pjFTwtOCD/7F7suxBWTFu50Ks="
        }, {
          "num_cand": "U2FsdGVkX19NrSWet7axWfg+3iEi4NiEuixPiJMaiEU=",
          "cpf": "U2FsdGVkX1/SlJT4gDu5JJy4UtwuiZKmzQwWznAG3yU="
        }, {
          "num_cand": "U2FsdGVkX183wPPfLS5Rjss6AbrMfCMjEjMHccuI88Y=",
          "cpf": "U2FsdGVkX18PNTGa7QUcFCIv2/h8QVGJP+L7DR3x7z0="
        }, {
          "num_cand": "U2FsdGVkX1/17EuWeuDU0yMhx3KDKjsOQZ2rOtJefbg=",
          "cpf": "U2FsdGVkX1+gBnuMul6CsEuCOO23Yl3acS9co+pCdX4="
        }, {
          "num_cand": "U2FsdGVkX1/hLswRO0dTWiWpQEXA4v/x+Np4noZs6C4=",
          "cpf": "U2FsdGVkX190XbGwotDWJhe71ZE5dRkqNC50fhGfM5Q="
        }, {
          "num_cand": "U2FsdGVkX18QvleLD+5MCiKYRgiGPjfQf8EQNTdZXiU=",
          "cpf": "U2FsdGVkX19SBsa7AlDbX3jO2DZ+tal1yRA0u84WMlM="
        }, {
          "num_cand": "U2FsdGVkX1/LmC0zkIRkMerrbjawBb8XmMe2GJXhmm4=",
          "cpf": "U2FsdGVkX1/yvJJIf9OLoWI4cnX6fSzyCGN5VxATgOE="
        }, {
          "num_cand": "U2FsdGVkX1+Ex++uGV2IDicXV5bpKZSpyLQNyoLvX+w=",
          "cpf": "U2FsdGVkX19afgCFjNMvfpIrg01PjQfS2t74+joDLJU="
        }, {
          "num_cand": "U2FsdGVkX1/2MR9vCuKbOVIjvumdWCmSFazwJCwxJ8s=",
          "cpf": "U2FsdGVkX189K5d+0+o1d0KjTnE1RZRrWzAwyS5N9Rs="
        }, {
          "num_cand": "U2FsdGVkX18cvtfWF9Rzl/GFFAK4Dr5qHwG02SS1/Ec=",
          "cpf": "U2FsdGVkX1/+o3zMCQJ3d9L4/vUgse40ZIlZHfWf7TY="
        }, {
          "num_cand": "U2FsdGVkX19a9nf9cLMCfdlWOM57QCBSCo7KVTYAugQ=",
          "cpf": "U2FsdGVkX1+wAuEPYFQ1mM910gFvcJXYwyIpuiAJIWE="
        }, {
          "num_cand": "U2FsdGVkX19EJMkhPz5jUtBmZshkW5v52vtRSGNqsXI=",
          "cpf": "U2FsdGVkX1/VgysASdVvHPE+hRq3hpDUFTAPAVgJ+XQ="
        }, {
          "num_cand": "U2FsdGVkX1+QW0C6J+++6WgHxQP0MXY+gSNJ1zgf8dI=",
          "cpf": "U2FsdGVkX1/npwE1z9lP85+XqqoAkrPnm6m4oA9zOCc="
        }, {
          "num_cand": "U2FsdGVkX19Vig2s1u1PpuvwsFMbhSm0QCrYGJph2/I=",
          "cpf": "U2FsdGVkX19go1tw4GDzT0znzznXGPeUZh8u97O5YBA="
        }, {
          "num_cand": "U2FsdGVkX19Ljd5znqjOIgO0odNpo/H6yVPUgVlBc8g=",
          "cpf": "U2FsdGVkX19/qlNiv/twj7qAv7JroV+u7dSPrA+N9HA="
        }, {
          "num_cand": "U2FsdGVkX1+3bhZjrq9Kmv5V7QDYsu3gvn4hMc5v3dY=",
          "cpf": "U2FsdGVkX18amy+pTT3leKJ4XYMSfP1dlXF2n2cUYDs="
        }, {
          "num_cand": "U2FsdGVkX18bT0QPLEYBZ7eMXp0H+jLTqP+ubxfhpqw=",
          "cpf": "U2FsdGVkX18ADUqqMm+/32+rhbeV+TJ5RWGhgmgpE94="
        }, {
          "num_cand": "U2FsdGVkX1+PkKQDEASquVneudCfh0Iwm83ggkDdpmA=",
          "cpf": "U2FsdGVkX1/ukyRwTnM4rhBhFMRmdtfiY1YjEQHlzHo="
        }, {
          "num_cand": "U2FsdGVkX1+Xl/03jdAjpLD01lT1W/FTevsTX+Neb8s=",
          "cpf": "U2FsdGVkX1+VbyvddyzIyQb97Vt1ZKLQuse9+BBKPvs="
        }, {
          "num_cand": "U2FsdGVkX19p+o/Htf0V9kZAaGMkpJXSkD3B6+UTX3E=",
          "cpf": "U2FsdGVkX19Y3PcQlXfqYHOP2Nyy4W+jBfLMZpTOg4U="
        }, {
          "num_cand": "U2FsdGVkX1+t2WW/5b1qMoDQOPneq17im7vhMCH872U=",
          "cpf": "U2FsdGVkX1+WF2ywXXzOrooW9h+D9ptjtciJth+Prvc="
        }, {
          "num_cand": "U2FsdGVkX19ua9TzmRPqlR6YowwcaHprjzgNXGBsSjI=",
          "cpf": "U2FsdGVkX1/4q4fzK3I5R5C1CZlIqXkSuksZ41Rco94="
        }, {
          "num_cand": "U2FsdGVkX1+5df41L67nS1+ojDWHo77rDhBVRmboObU=",
          "cpf": "U2FsdGVkX1/F+Ekn1OMJOwStPPA7DWNWetN+JwY75eU="
        }, {
          "num_cand": "U2FsdGVkX1+CirwA8yPT/gQhZfLb+3w4BLjGywBbI6Y=",
          "cpf": "U2FsdGVkX1/ltP+398ABS9GKA4SwycevjVf8r/zae/U="
        }, {
          "num_cand": "U2FsdGVkX1+lVWzuz7S7lOI+iZdB39dXgdlVSbPoPxU=",
          "cpf": "U2FsdGVkX19ORWfUrDtDO/D7h4/POII7K20zbicILvg="
        }, {
          "num_cand": "U2FsdGVkX18QHtPmn2cHd66jl89yHQ+fj7F2GEoI674=",
          "cpf": "U2FsdGVkX1+EqCVDAvtidczOUI+wqq0/P1ymUljYiwQ="
        }, {
          "num_cand": "U2FsdGVkX18GQtR3qjCz6rp0bmOB14oNvxUT9JgN35I=",
          "cpf": "U2FsdGVkX1/C3KjI2BCDjOg05JY3hxXvdRnrosvS3B4="
        }, {
          "num_cand": "U2FsdGVkX19/SLcojR8vUn2D4HVl1geGWTxmaJNqK9E=",
          "cpf": "U2FsdGVkX1/wp1lKSEWhD1XUFGOrLnra7fIqCg2uXUc="
        }, {
          "num_cand": "U2FsdGVkX1/W+vSxO00GxNzm4UTwRngm7iDXY+qgVhU=",
          "cpf": "U2FsdGVkX1/KiU7/zLlAFW7FIjswoKT9W8k5Er4wJ08="
        }, {
          "num_cand": "U2FsdGVkX19B1TceS5DXtM5qC9cuJSjN03nUs6jsiYY=",
          "cpf": "U2FsdGVkX1+D2V7GmJlb6EcXEL0876uKYB2/6U02PeM="
        }, {
          "num_cand": "U2FsdGVkX187mCr1cDM7hn02hJ7hPNzO+V72dWCqvjY=",
          "cpf": "U2FsdGVkX19Kxri5H15WYuTaxTIH457BLWV++VwsaoM="
        }, {
          "num_cand": "U2FsdGVkX1/MXQLZBdFBAyowF6N4Yb/UexoruiJwJJM=",
          "cpf": "U2FsdGVkX18lH3saoDrzkfpGQ1g0qpEkFfkqF2lVVxU="
        }, {
          "num_cand": "U2FsdGVkX1/1dLcxn/ELPvJ6cRgnQKeNYYfQ4g3Q6JM=",
          "cpf": "U2FsdGVkX19Wt9vc9W3jOhGyxiEWBm5LXMPIQngYvWg="
        }, {
          "num_cand": "U2FsdGVkX1/eX9Z3D8ylxwiVJHgfiBaPwtneYpWl8OE=",
          "cpf": "U2FsdGVkX1/NKfydaS5yYXbAL9cH2+aNZR/RU9egjxI="
        }, {
          "num_cand": "U2FsdGVkX1+d67m/jHZIj4zgcXyP4sRHRUyjGuuKsV8=",
          "cpf": "U2FsdGVkX1+5UTZYyPN6DIKPhERD1Vcsvt1Iu92SkOI="
        }, {
          "num_cand": "U2FsdGVkX1+YZ0HFQYQESkleWPZ9we2SGg/FF195IH8=",
          "cpf": "U2FsdGVkX1/2F0l1WBsj/wUOmKiGQ7tekLCrWU5sDW0="
        }, {
          "num_cand": "U2FsdGVkX1+5ZvcPbUtF8u3u41pGSMmO8lckz4/6Sok=",
          "cpf": "U2FsdGVkX1+nsoy0GgX7SFhM/XN1SBsFHQqkEFPQOps="
        }, {
          "num_cand": "U2FsdGVkX1/f4CbjTziNBybwFa6iJWQiS0H95YDg48I=",
          "cpf": "U2FsdGVkX1/vjqqhOEcUUv5vfXQ3geU3sD2COiucgUU="
        }, {
          "num_cand": "U2FsdGVkX18G74wHxYSaDKu9M2Gpz/Ye0mf8VNLuxo8=",
          "cpf": "U2FsdGVkX18gqykzr21Mt233gORbC/cZomf5K0zCIk0="
        }, {
          "num_cand": "U2FsdGVkX1/9gh4WXhfmWlZ+Z5b4Tz53Qsmy5u2xgRs=",
          "cpf": "U2FsdGVkX1+PjH9Xcb2bUNVxwe/9wKiIu3wzdI14KKU="
        }, {
          "num_cand": "U2FsdGVkX18t7B975x6Eht882aUkp1DEbpekW6zPa/0=",
          "cpf": "U2FsdGVkX18Ui1d9js9/lqUJJEe/GYMRAteyRzqcnQQ="
        }, {
          "num_cand": "U2FsdGVkX1945lZmo2i1dC4whS+KiJhuST8FpuWyu/4=",
          "cpf": "U2FsdGVkX1/JdzcWFuxswMYPHj0AR/Kp9SgF2E3x1pI="
        }, {
          "num_cand": "U2FsdGVkX18VQWzLzdOHpmHjHHUx3iQqjqiuXlYyCxI=",
          "cpf": "U2FsdGVkX196acNTXOASzwNDuSEOE0tpo140K5aiwzU="
        }, {
          "num_cand": "U2FsdGVkX1+OJQfe3GwhWBU9q06D6LzLI0/rDNcTd3M=",
          "cpf": "U2FsdGVkX198DkpKVHE+dVIxRe+1VMJYamwLszy+Dys="
        }, {
          "num_cand": "U2FsdGVkX1+/ZL/cg2bIcrhcWUmGycAsxBmt8/9r0FI=",
          "cpf": "U2FsdGVkX192zRXqJurCwN+jVf4kLWcG0mxo9F+HQ5Y="
        }, {
          "num_cand": "U2FsdGVkX1/UqlvpWSfbK9lkCUHnC1YcEkUoVRQf3OA=",
          "cpf": "U2FsdGVkX1+AOg5YeY9IWoeWOjlo0OjlKmIi6h2wBxA="
        }, {
          "num_cand": "U2FsdGVkX19LMmjraW03H5NPsEPPrJ0vHLufXvPrvZE=",
          "cpf": "U2FsdGVkX1/ThVjsry4jLEhG0K1OwPe6/MT+Mv/OX2w="
        }, {
          "num_cand": "U2FsdGVkX1/PCU6HHYCziDUeiG4MqEIalWDvNrQVzp8=",
          "cpf": "U2FsdGVkX19tSox1T+apw8cwjTjshoXXPA28IUaXVMs="
        }, {
          "num_cand": "U2FsdGVkX19CBLT1DyDcAn+mlfXmPP1FWpt0W0tcYE8=",
          "cpf": "U2FsdGVkX18QYRWfqvj7vBoSsMrs2tQCQlrPSbpMmYo="
        }, {
          "num_cand": "U2FsdGVkX1/CPYOE6f6T0r48I46ndZLMSXwKdyehLN0=",
          "cpf": "U2FsdGVkX18FgeshfGFqKGi3z10+ra3UGQUR90zBSbo="
        }, {
          "num_cand": "U2FsdGVkX1/V6gPYZIvvKztQaFWNUVlhIauaOCYyReQ=",
          "cpf": "U2FsdGVkX19+tA2vdvaEwt1ottlWmxI/ApG6R0NIhGk="
        }, {
          "num_cand": "U2FsdGVkX182i1X6nREH6xeqxCUKIBIM/Ba8xhaMUVM=",
          "cpf": "U2FsdGVkX1/36P0J5SMKm1d75FIzSJ6bi9N7FNf4WMY="
        }, {
          "num_cand": "U2FsdGVkX18OEn64bpH4ScjAp5Gmtg5dAFBLoViMhUg=",
          "cpf": "U2FsdGVkX1++J0ZU8ExE4jOm0SCxuGj0iHQR6SjXzQ8="
        }, {
          "num_cand": "U2FsdGVkX1/xAyrZFGjsiOV09XJMGqoIw8mpzJOJ6Hk=",
          "cpf": "U2FsdGVkX19FJxnKhN2+9cGgYORFtoCLOcQuxBaNk60="
        }, {
          "num_cand": "U2FsdGVkX19lHqowb+VkyhW1CYxFh3N9bq3XPzSIhtQ=",
          "cpf": "U2FsdGVkX183X8KVTHnBCC8QLWMCjyC1ScsyZnQq82k="
        }, {
          "num_cand": "U2FsdGVkX1/897B+8QZ7Ov88pz6Lhs++PrqHIqJYfpg=",
          "cpf": "U2FsdGVkX19r2f0BkRG267/FECH8l0YlQ3e1S0XDWg8="
        }, {
          "num_cand": "U2FsdGVkX19a1C2VH6uUKyYVXcqZ5R2yc27Hs/3InDM=",
          "cpf": "U2FsdGVkX18aCmiymbvf2MCYzpNJuErrOkBU5+STGdE="
        }, {
          "num_cand": "U2FsdGVkX1/VcjgtQ8CAm9QePkcXQ2IdWiJ8hyDdTAM=",
          "cpf": "U2FsdGVkX19LgRBh0p6kT/bbEqYBSH7sLzdlwQbRX0Q="
        }, {
          "num_cand": "U2FsdGVkX19d5ugh10J1vT5VSWuc+AgiRZNk78SjKJk=",
          "cpf": "U2FsdGVkX18GiX/UtobpNcFThlRTK3gX5gtcH3N720Q="
        }, {
          "num_cand": "U2FsdGVkX1+7VLbzJo+9aG6gNL8quDbkyq1kUIhflQ8=",
          "cpf": "U2FsdGVkX1/g61mS6k36gcbpRxoKWug5Emz6tYILOXA="
        }, {
          "num_cand": "U2FsdGVkX18V4VVQhpSVYu2shCAy9HhCoKFCgwWxnG4=",
          "cpf": "U2FsdGVkX1+nMq3QNtZWaTNeze519eXimjOlM9M9Hb8="
        }, {
          "num_cand": "U2FsdGVkX1/Ro1K4laCKVhzAo1hYgQpZ0R095EvBBG4=",
          "cpf": "U2FsdGVkX1/7THlo5QvjPpnje1lVuntdFDp+D+5U8uo="
        }, {
          "num_cand": "U2FsdGVkX19M6jAxZ8/neDJxoARaCVks2XLaXeeFzPk=",
          "cpf": "U2FsdGVkX19x8VAyP1gqHzo/fz9bbQM81eb21UsT3uk="
        }, {
          "num_cand": "U2FsdGVkX19SMGBbASY/Grlwd6Yg/sdQV1ZVW7mtBRo=",
          "cpf": "U2FsdGVkX19fgLPEwEQIRvsA+oXydZrHBymvKdOrt+4="
        }, {
          "num_cand": "U2FsdGVkX1/J6IYKaksh4nq/Kx5GYhDUe+Qg7HNT6EE=",
          "cpf": "U2FsdGVkX1+8bCqy2jGZTknpXLMX7SwMUPSOG0E7dro="
        }, {
          "num_cand": "U2FsdGVkX19w0CuQbafG1hP89XfeQFQQHDRHV1wbUGw=",
          "cpf": "U2FsdGVkX1+AI6rS3l+Ugxn5zhQ3Tcc8sqOQ/q1K81E="
        }, {
          "num_cand": "U2FsdGVkX18z493oauFDj5juZN0dk1w2Ek905d7giHk=",
          "cpf": "U2FsdGVkX18ObK5nOmGR7Val5xYAtwjbUroGwr+6yr0="
        }, {
          "num_cand": "U2FsdGVkX1+MA6A83v5Gmozeioc17BoI21A+EMbhxr8=",
          "cpf": "U2FsdGVkX18yNgNjjcluvJyJabXQ6uLnAfwR6JWQjEk="
        }, {
          "num_cand": "U2FsdGVkX1+GbxoZ9SzLfWpk9PZffVesveHu6JKIS6A=",
          "cpf": "U2FsdGVkX1/ITdh3mWyKXGdJAyqiELCN+5bSHzgeJfk="
        }, {
          "num_cand": "U2FsdGVkX1+wzLSH2+Uh23tFjbTlQYohz7H6ANg2jX0=",
          "cpf": "U2FsdGVkX1/sR2kiq40GCqWfoMRKhqaS+xTgcowI40U="
        }, {
          "num_cand": "U2FsdGVkX1/2vP5DaLLyG78SuKixfAHNIs8I0NWuroE=",
          "cpf": "U2FsdGVkX1//xO2pQU3Ohc3IM2bvkJNgMVz8YuOB9ls="
        }, {
          "num_cand": "U2FsdGVkX1/yD8qapBFvlFmI8/g0ZM4/K4vqmlHtAwM=",
          "cpf": "U2FsdGVkX19+KBr9e8cDxR5MrH7ugLyNdEVFfL86I00="
        }, {
          "num_cand": "U2FsdGVkX19Jyn81e7lzaFt0cbcO1+lWfx/ovIrqNQg=",
          "cpf": "U2FsdGVkX1/EfvdThoHxcabIq0C2isT/Z+hWDEeIqAg="
        }, {
          "num_cand": "U2FsdGVkX19fRvccg5eahlTYF0sQ9SbFySb1fbZqJYI=",
          "cpf": "U2FsdGVkX19QNQuy4c+xa4eQjZM3E2S0kFq5Ar0mMrc="
        }, {
          "num_cand": "U2FsdGVkX1/QiHCqai8wZ61PUfp+JiMW8wyevxhE0XY=",
          "cpf": "U2FsdGVkX1+pL4s5oyIggr1bAkjwBJQWoEm5qwVz6jM="
        }, {
          "num_cand": "U2FsdGVkX19gdf3KATFwq3+qhqBrCWTODa/STjFM+5k=",
          "cpf": "U2FsdGVkX1+rklWaZTQko/MpKF/WPe1NH1lnP718GVE="
        }, {
          "num_cand": "U2FsdGVkX19l3kKHz25KH8rf/Pgrz+SuRkNB4bdmwZA=",
          "cpf": "U2FsdGVkX19MJmr7A12WKVuujNVfBbMTmZgqOdGA0TY="
        }, {
          "num_cand": "U2FsdGVkX1+5ci5B+6sKbcVn1UOb986wMoJI6vTpVL4=",
          "cpf": "U2FsdGVkX19qrxFWFQW7F5VFm6qPpaTmP+M4Mc9P8HQ="
        }, {
          "num_cand": "U2FsdGVkX19sPzonOMVNaEmMrghA5JW8lOcsX2aGQFc=",
          "cpf": "U2FsdGVkX18eMaw9Ryo+6eAajye3bWUYSE3TuRSx5JI="
        }, {
          "num_cand": "U2FsdGVkX1+qi6/qlofM0Mh+tAI7I36em9+H7O5Tpfw=",
          "cpf": "U2FsdGVkX19pbBxEYq8vcboxjB9GGKeoEbHk42zv45A="
        }, {
          "num_cand": "U2FsdGVkX18Xx+Tu6JsFZU9CQvEKcDhVKaNHssTVQ7w=",
          "cpf": "U2FsdGVkX1+aEFPEduQu18oKaMcL5vzD01z8RnMNxhc="
        }, {
          "num_cand": "U2FsdGVkX1/wpl9I5dAhdpBVaZKQEVH3vrYiDpozaI8=",
          "cpf": "U2FsdGVkX1/x1k/ATJmdCLAxAWPNSUy/ueK8/9yP0lI="
        }, {
          "num_cand": "U2FsdGVkX1+LlCNgpmvA6qCA+jcXH40f+tSJ8shUVOg=",
          "cpf": "U2FsdGVkX18Yy/s3/smt/BDyQDDMmNrQI9YGTE5oqgY="
        }, {
          "num_cand": "U2FsdGVkX19nbeHKdbW8kcMaeZhBjUqqLHDX5b5sEtY=",
          "cpf": "U2FsdGVkX1+27PqBEofz4sN4yUH8TKrHPb+Zh8rZAqI="
        }, {
          "num_cand": "U2FsdGVkX19IkLIgx1L4UdrKf4DJKGGBRGp0jxPH4r8=",
          "cpf": "U2FsdGVkX19EwWezsT55y3bYyU0/bDN9OwV8sXyCZdM="
        }, {
          "num_cand": "U2FsdGVkX1+Em8SzAMHG0DfTFjFtbZeuIiOZE6GtgE4=",
          "cpf": "U2FsdGVkX18EmjgdGNEyhVnj+9wDemBsWsVjhvtb/yA="
        }, {
          "num_cand": "U2FsdGVkX18bCfwYdjVGrBpOrVbnzznUZEUhiVyK70A=",
          "cpf": "U2FsdGVkX1+3u7MSbywzahx7JaAfZinl/g2MsntqiTc="
        }, {
          "num_cand": "U2FsdGVkX18q5AQHQTFysgxpp38dSL/LAEzcjVxKeNM=",
          "cpf": "U2FsdGVkX1+5CL14NUufNoB2FMPOLyKhT/jyq3o3pzU="
        }, {
          "num_cand": "U2FsdGVkX18ZfzTn3snz2MJiphMYdWO6tO5dardsG2k=",
          "cpf": "U2FsdGVkX1+7cTVx92hbSzuGFzbVRPuDaR/d3Vsc6ww="
        }, {
          "num_cand": "U2FsdGVkX1+SV6jBYMknaqNevkwJ7E90iA9oTOuNGdo=",
          "cpf": "U2FsdGVkX1+6x/8JWMlhw4AI/1NZsXjUa+eYPum8nTs="
        }, {
          "num_cand": "U2FsdGVkX1/FQ63rnvqqoz/3xRHZOLc7ZTrQZta/XwY=",
          "cpf": "U2FsdGVkX1+9wTNztEYv7l39/7+pvOBSzFeBm6VLbZA="
        }, {
          "num_cand": "U2FsdGVkX1+dt48phypFVJ5UKJcGZ3ZOihqTXZVSPuU=",
          "cpf": "U2FsdGVkX19O8xyd6AKTrerv3LZP7Wu2yHfO2G7A+mA="
        }, {
          "num_cand": "U2FsdGVkX1+z0XLhNpeq4HElluwJosPPKrO1hVK1gYo=",
          "cpf": "U2FsdGVkX19MgX/++kxn8FLFDeSXD8l+FBK0pJNsZjU="
        }, {
          "num_cand": "U2FsdGVkX18RW68NzY4N4yooAzLfQMXctT4hlMVQaCA=",
          "cpf": "U2FsdGVkX1963Yo7vsKA7NZHtxlygCiKLlBZJM5mfwc="
        }, {
          "num_cand": "U2FsdGVkX1+8JN9F6C56nwuTfR+ZJBEwHDG7elDWUc0=",
          "cpf": "U2FsdGVkX1+v0IVdyw3WnKVB/LzWYDq/u6FYGHwB7jM="
        }, {
          "num_cand": "U2FsdGVkX19AznDW0mBXwv0k/6+M31DzqW0a8f4dlIM=",
          "cpf": "U2FsdGVkX191Vy9PHUXMwd9ZIUwDDsy+BgWDUqrmaRU="
        }, {
          "num_cand": "U2FsdGVkX18jtN50a3axcrnW3sOHiajb9sZJlIV1h6Q=",
          "cpf": "U2FsdGVkX19z6JLDTBw/FuYzqyvD5gPQ97m5M08/RQc="
        }, {
          "num_cand": "U2FsdGVkX1/gWgj1vJr2bwgcEoOOgelSTlszBIFkE8U=",
          "cpf": "U2FsdGVkX1/PpjJtSbEMV8J4zCRcz28gk5GQZXwxKUY="
        }, {
          "num_cand": "U2FsdGVkX1+wa2w3888lhd8JAKsloNOC+eA+W4/Obnc=",
          "cpf": "U2FsdGVkX18E80kMmDOzrxV/7ehnHKqF/fW9fq1qPYY="
        }, {
          "num_cand": "U2FsdGVkX18BvMJqjyckAyeyEdN0DP1iwJxfkxW7ljY=",
          "cpf": "U2FsdGVkX1/2qEkB9EQJH8B3My8ciS3zl1n8MBcakEA="
        }, {
          "num_cand": "U2FsdGVkX18yWZ7w0SsAAlUvQOwN+/4TRavluH20c8g=",
          "cpf": "U2FsdGVkX18eDVDJmTBaS/j81jJZBZbQggcOAjf5bPs="
        }, {
          "num_cand": "U2FsdGVkX18xLJzPmH1g21jjoeFb5ncWH58OXiPcYJ8=",
          "cpf": "U2FsdGVkX1+04GzTNhFdIHMLq/gYMvarl9HIbhMta+Y="
        }, {
          "num_cand": "U2FsdGVkX1/r8YFO43w/jEvLN+8sxguJnXjBPZejMcc=",
          "cpf": "U2FsdGVkX18/cX9Ul7Qw5/fNaZGYupxSAxNY4rlroCc="
        }, {
          "num_cand": "U2FsdGVkX19/eEvrp0WxKSZzQ+6m4zolmVzTzdc6loA=",
          "cpf": "U2FsdGVkX1+8jeIDC2dAnfGq+bOjTUn8mYDz2OghJm0="
        }, {
          "num_cand": "U2FsdGVkX1+BHBtylEmRpU07YCxhtHtT0gkTee2Bw0I=",
          "cpf": "U2FsdGVkX1+iqtDFdtKIS0LvJMc0TaMCeUPtNk/cL8w="
        }, {
          "num_cand": "U2FsdGVkX1/K9VCE8VQw7q5WqkxXNRXWXSlLGLVWNrk=",
          "cpf": "U2FsdGVkX1/q52o2vU+SxgjKhUJbjOhamcBgB86bNhE="
        }, {
          "num_cand": "U2FsdGVkX1+P+Jj1Y2xmMitShghnu8t2wXN1Ra7TJ4I=",
          "cpf": "U2FsdGVkX1/BG1S9fnozQ8JwZC2l+JMX4nwe4vlg1GA="
        }, {
          "num_cand": "U2FsdGVkX18x1gtrry6bUlywC88oYrKrLGQS9SrDTaU=",
          "cpf": "U2FsdGVkX18+rHsiQPaxG950A6SRkU6yUmXKf2Vebl4="
        }, {
          "num_cand": "U2FsdGVkX199GJS+LL87mc4H1ROUlST8Ud61w+3UDVw=",
          "cpf": "U2FsdGVkX1+23bALlF4J0lM3EW/1Pu/ReF7ApkBDaJo="
        }, {
          "num_cand": "U2FsdGVkX18KpGOacl0hy5JdD1+BXBWb+YOZI5UjCGU=",
          "cpf": "U2FsdGVkX1+j1arSAud/XogRKfXp1+tblldVv6CGZR4="
        }, {
          "num_cand": "U2FsdGVkX18fqamLPefjrXgIdNhLMAmWcUvJ5Sq5Eak=",
          "cpf": "U2FsdGVkX18OAobLL3hfD3tAGUS86e2DK0oEQJyoB/w="
        }, {
          "num_cand": "U2FsdGVkX1/0zgKMg8mBchiArOM6a0vdmNsosZQepf8=",
          "cpf": "U2FsdGVkX19U8eoENPpE0ZiUW8IFlFfibzLKV5HtjMk="
        }, {
          "num_cand": "U2FsdGVkX1+TknV8UICWe8jG2YH0j4w20sMWcDWcl0U=",
          "cpf": "U2FsdGVkX18EMAqf9fZOpD+6UzWS0JM7+9rgs1F4/n0="
        }, {
          "num_cand": "U2FsdGVkX182rKclcQKD3D5uvAGh1+lOzoen+MJ0b34=",
          "cpf": "U2FsdGVkX18Soh30ySe29mM9P6YHaqFiArXCJ67RFVI="
        }, {
          "num_cand": "U2FsdGVkX19QmVHLdhq+1jiGqU5xT6lneM54n4obyVM=",
          "cpf": "U2FsdGVkX1/T1899bGng8Y1yrxmnwm5QlmPhNH7AtkY="
        }, {
          "num_cand": "U2FsdGVkX1/iM950PLV2UsatrW0OVK5f2EoiSaomD2k=",
          "cpf": "U2FsdGVkX19Ojm28qPN4jgkplc8wVc93FtC3kyU/Cdc="
        }, {
          "num_cand": "U2FsdGVkX19swft1Vusb60bCXNsCAUQoHryIvEmqOBs=",
          "cpf": "U2FsdGVkX18EG2BGL2E3ypE2gfeziNOs9458Wsh63fM="
        }, {
          "num_cand": "U2FsdGVkX1+vBULVBHx/ZP4YLH26dgBd9bt0vec/ris=",
          "cpf": "U2FsdGVkX18UFy+J9G+ozFxlySN0In7Vi7QW3ZJ8/Co="
        }, {
          "num_cand": "U2FsdGVkX18yW1h+Vw+wY5+E8RxkK/iDgAzyyf7LVx8=",
          "cpf": "U2FsdGVkX195xGUqsLyWRi0lMsW6IeKuMCqDsHzHygY="
        }, {
          "num_cand": "U2FsdGVkX1+L6g17WnkueRka9q75R5/aRlbrOSHiEfQ=",
          "cpf": "U2FsdGVkX19/okShoQHuwlw1OJaR9fCyQvnbVb6BTRY="
        }, {
          "num_cand": "U2FsdGVkX19Lmsb5V4SpMuSDow/A6+dKtT6u98zQ12o=",
          "cpf": "U2FsdGVkX1/lcuQaJtoCTBa2MOUdEa0HidMlrntt7vo="
        }, {
          "num_cand": "U2FsdGVkX1+uAblAcRz+dUQdetTUP9owkFfhP/89iSE=",
          "cpf": "U2FsdGVkX19NdRbiinjTreEDEr+TF2JwYG9kGByrKK8="
        }, {
          "num_cand": "U2FsdGVkX1/3ENd6FxJcB4SpuEntovbqyFG+tQJxkr0=",
          "cpf": "U2FsdGVkX1+x6CZ7FsFoiYpHJaOSgVbbZcPVdcG11C4="
        }, {
          "num_cand": "U2FsdGVkX18NliKt5dTU97VFLJeZ0Ado+fi95VlTw24=",
          "cpf": "U2FsdGVkX18lySnv4P3OQ9UjDA7h9M4EnDSSLIlHrR8="
        }, {
          "num_cand": "U2FsdGVkX19EFuXaZqs4R5yr006f1gsrUxFRsvcSoZo=",
          "cpf": "U2FsdGVkX19aheSlWHNKISLiLvwXgI3XhtIE/wdA05o="
        }, {
          "num_cand": "U2FsdGVkX1/uYGaruM+iCyYdRVGRJ1cz1FmtXdHdhqk=",
          "cpf": "U2FsdGVkX1+p8ETV8AY/+kovlm60x0WjuOiGJerrZ+E="
        }, {
          "num_cand": "U2FsdGVkX1/JnYnyGw6Wx6VyiTd4L7bP8vWyajWslXQ=",
          "cpf": "U2FsdGVkX1/pRWoFw8678/sL3fA9/bcOlEhQLAuqXhc="
        }, {
          "num_cand": "U2FsdGVkX18zNIikcuKBTp30Ua0s9UTk+b6+LqAU9x8=",
          "cpf": "U2FsdGVkX1++A8VB7PWBbIdepnPeAmIyeDlExUwr8cE="
        }, {
          "num_cand": "U2FsdGVkX1/U70uu+L3y0Kx7gmPMUMG5OhNOqJ8vn1Y=",
          "cpf": "U2FsdGVkX1/lFh6PUAGVmHNNhruw/7Q1Ik4hC8xsk4Y="
        }, {
          "num_cand": "U2FsdGVkX1+L1wurqROtirkV17xUeip+PhOKT+ltSTM=",
          "cpf": "U2FsdGVkX1+3u8B/oy8OTPmlP+LStzCfpkmOao51TKc="
        }, {
          "num_cand": "U2FsdGVkX1+jb16YDWEVeClhYLeQ/0u9iRzDMZMU7KE=",
          "cpf": "U2FsdGVkX19ZJPfS3Y9y4zKmF7PoxdIwptoRCGJUQpU="
        }, {
          "num_cand": "U2FsdGVkX18dUYPjvs5FT8WNBKz8PNZKAGY35UrUF9U=",
          "cpf": "U2FsdGVkX1++ZCmTsqpZYXA+W7P7u1yKMg1CQUR3iho="
        }, {
          "num_cand": "U2FsdGVkX1/Wq74NorCTSajiu/5Y+nV3ghrDcYU+FDM=",
          "cpf": "U2FsdGVkX18glwETtKfwqziOtLB1XsPlNRrzpRP0+00="
        }, {
          "num_cand": "U2FsdGVkX1+xN0aDdsAVpa3cyWagw0lMMSiDJkoOjds=",
          "cpf": "U2FsdGVkX18YsWbnbEqSz3uj95w6H636NHUfwp1tBts="
        }, {
          "num_cand": "U2FsdGVkX1+VNB/KaTs2xYC+5wSZPy7w53PGyM9gV3Y=",
          "cpf": "U2FsdGVkX1/pTSGXyO4muIQ88j2nPIzdHdSKl4+i5UI="
        }, {
          "num_cand": "U2FsdGVkX18EIa9KErgLBnpjZ42OQ/CABejnAqWB3Y8=",
          "cpf": "U2FsdGVkX1/3AUQRpfnsX8/w9rE9CxKf5ybxaI0aja4="
        }, {
          "num_cand": "U2FsdGVkX1+K0CbgwoTZpiehlHXIyvW8nuhXW4iEhy0=",
          "cpf": "U2FsdGVkX19r6ROqLFC3PiXJK9G7TzIVn5biRPJbi8g="
        }, {
          "num_cand": "U2FsdGVkX19RdSE3La9HEtqJX/whSzAv8kJvcQqfzwI=",
          "cpf": "U2FsdGVkX1/wAtBYkTzxsTfp+O5/z08PrDVXseqmXzA="
        }, {
          "num_cand": "U2FsdGVkX18YZGZkfw+96ssQulGrgi5LnROBnVuza8s=",
          "cpf": "U2FsdGVkX19qxU2u3YG0bkIjcgsiNEfqIF7FNjeHgpw="
        }, {
          "num_cand": "U2FsdGVkX19Pr0Z7FX6T1g1KJij0tVFCACPTq7GHfj4=",
          "cpf": "U2FsdGVkX19ZdRXpyca0DAXISo66QD3eOY5Jy30ELHs="
        }, {
          "num_cand": "U2FsdGVkX1+o8YEt2Flfv6L8QD+mR4obsed/RrDPVyo=",
          "cpf": "U2FsdGVkX18XXt9GWSmIAyOtyjgbtHrpYLvhgZbP8Cc="
        }, {
          "num_cand": "U2FsdGVkX1++fSqQuZ0MnSUYuxrCmCmfc1JScKrPO0g=",
          "cpf": "U2FsdGVkX1+ox/IsMUu+EtaodkG1kUprsuCkqB9pKSM="
        }, {
          "num_cand": "U2FsdGVkX18QNwOQ7xR1DJGPychWuataVWB8fkL1L4k=",
          "cpf": "U2FsdGVkX19xavzbCD57T9O2XyoGr35JS7SEfIZ9C7M="
        }, {
          "num_cand": "U2FsdGVkX18wIKaSFVOEfKMJZvyTP67zx0suWf50YiI=",
          "cpf": "U2FsdGVkX194K9N8pbe/LKsU0kddjIwXeRCkotkGhvA="
        }, {
          "num_cand": "U2FsdGVkX1+3+M+G/ofnF+t+oswxmiE6mAS0uqtJykA=",
          "cpf": "U2FsdGVkX19tlbkTRbhlZsIZEb1tbzQx1BN9CK8PZ4U="
        }, {
          "num_cand": "U2FsdGVkX1+87PbbrxJZ2zocKbDcWj21jd5UbXoLqDQ=",
          "cpf": "U2FsdGVkX19EH2pHP2aptSPHaLuWdsFYIXeArkFwOiQ="
        }, {
          "num_cand": "U2FsdGVkX18K4U4vj6mcPwXuGVT2a2sig21qAfBRuT0=",
          "cpf": "U2FsdGVkX19BjGjo4i0tWjsWzVhHJIdPL3Io9HtMxKg="
        }, {
          "num_cand": "U2FsdGVkX1/06ET50H2HNKazGxvbnG4t5cg/PV0eVEk=",
          "cpf": "U2FsdGVkX19jtSz3whtHzp0KOU3Rt99sDqjPsY9cDI4="
        }, {
          "num_cand": "U2FsdGVkX18vguWqkb+CtCBZea6XqluCVEcvUwTInz0=",
          "cpf": "U2FsdGVkX1+kVOowWCYGF0OZyTKr6g6MJZUUMARbE5I="
        }, {
          "num_cand": "U2FsdGVkX1+T53OCF2pA3eqf8RewMORUN4bJFTE/b3I=",
          "cpf": "U2FsdGVkX19ElNQlXmSL3pYGfScRMu9XLmvnFjPg970="
        }, {
          "num_cand": "U2FsdGVkX1/vmxkVuOUv1KLotaHXX8vrxQyuBtHmk6A=",
          "cpf": "U2FsdGVkX1+SNWW4PwmHFvaBPOEz1SD8a76iZUybAd8="
        }, {
          "num_cand": "U2FsdGVkX184LYZt7+aRRngL9LoJbSNBVDX/RXfEZgQ=",
          "cpf": "U2FsdGVkX1/KpKF/CTtRCaw9MksGo5XwUDUtUmgWrgY="
        }, {
          "num_cand": "U2FsdGVkX18rJHfMSec0Y97aL35KgWKxhk8GxoS/rgU=",
          "cpf": "U2FsdGVkX1+E48UAs/yeX1lCpmaOQ8/pEhXmgeyIBzw="
        }, {
          "num_cand": "U2FsdGVkX1+qhJEM/qbL6OaYO2XPO1EY5qeOQgGTFWg=",
          "cpf": "U2FsdGVkX18uby30EV37PKs8IPnWl97ff5RXluQmCH4="
        }, {
          "num_cand": "U2FsdGVkX1+vXUNV2//Un1fBqYUcDUg8qpmzzAPOlqY=",
          "cpf": "U2FsdGVkX1+rFjBPdaAGFyycY7OZoRkBS/mYOfiGmcI="
        }, {
          "num_cand": "U2FsdGVkX18YyQg+XncN9WFMhem7uWmIb9ZT+DZMmAI=",
          "cpf": "U2FsdGVkX19Ef38Ocajxf2vMp+ZcDMr9EZ0MvoTlJkg="
        }, {
          "num_cand": "U2FsdGVkX1/1brGPHk4c2KOZ4ynicWYIkBU7Tpyl4oo=",
          "cpf": "U2FsdGVkX19w4v8myOoSyngG6Qc4p7jd5+YJuVE83Bo="
        }, {
          "num_cand": "U2FsdGVkX196XfWBsYrTgGH6uSOxyYd7ObhU7NgyZO0=",
          "cpf": "U2FsdGVkX18WsR8Ms8EeVpJ/noUPMCQvWEKRidpDoUI="
        }, {
          "num_cand": "U2FsdGVkX18XK5ONzxUEswRfqKBDjS1KEq4OKXkCsZ4=",
          "cpf": "U2FsdGVkX181Eg4DIUMXq2zsonz1FPDWSoGlGUxaUME="
        }, {
          "num_cand": "U2FsdGVkX1/2V10wwec4FtjOg+/DO2L/N3KmHOPQPAM=",
          "cpf": "U2FsdGVkX1+z+XqG51J/cbww+6qydfyawxCeTN5/HWM="
        }, {
          "num_cand": "U2FsdGVkX19ye1N4GNZci0AZizZAxpezOdwpUHu7CcY=",
          "cpf": "U2FsdGVkX187pIxSLic2Ng9I3ODIQrcmO5EHzYfq9nc="
        }, {
          "num_cand": "U2FsdGVkX18QcNToaSWd2zhK79QzkUDS/Y8HyR252PY=",
          "cpf": "U2FsdGVkX1+VTLwlB4wyzxg0uKQ84xdlrO8LJMbyxmw="
        }, {
          "num_cand": "U2FsdGVkX1+R8iTupcHylQIZNjkK17bzAGydoCPWiQ0=",
          "cpf": "U2FsdGVkX1+8eerbNk9DGc8AJQzv4vFe4Rt+PfQAP+Q="
        }, {
          "num_cand": "U2FsdGVkX19XjntLyM1vstqzB7E6YNK7vig2jskJP/U=",
          "cpf": "U2FsdGVkX18Ofmxo3Z7upVTicwCp/7Bx4fbLHz3f1Kc="
        }, {
          "num_cand": "U2FsdGVkX19BFdx+IUDltFvRZrrCH4Cw0QgJ2rUUTPY=",
          "cpf": "U2FsdGVkX18jzGmHaxRejwrx3o6MMLgxKnNZVuT/UWM="
        }, {
          "num_cand": "U2FsdGVkX1+ONIKzM+0g2rt15ygMLZzKJqky/8BaYEM=",
          "cpf": "U2FsdGVkX18wKEtisgafJyDzmA0nzCp87yqgwZuLtbo="
        }, {
          "num_cand": "U2FsdGVkX1+Xuwsd2YLgKuK5RpmBeKpqn0YANi8d/2Y=",
          "cpf": "U2FsdGVkX1+k4do3fRU/cSkTgFupp+OF35hs+N5eW8Q="
        }, {
          "num_cand": "U2FsdGVkX1957BIrHKxpyJK36g9QrZbEBf+wyJZ3UiY=",
          "cpf": "U2FsdGVkX19ldN5gHA3Gij7TqzAbqjFpGx1m0T43Tug="
        }, {
          "num_cand": "U2FsdGVkX192oTD3mnDg5G8+JWQdKjXwtD2FAapIQi4=",
          "cpf": "U2FsdGVkX199L/K2HyDxwxeLmXOLRZP2CsEVtI8ZTU0="
        }, {
          "num_cand": "U2FsdGVkX1//Ndx6Uznye5W/1qV4Q5fdfjMcoqPMCfs=",
          "cpf": "U2FsdGVkX1/+VDQYvUjiFi7ZrwCnVgp3UpdIN0MU/Oc="
        }, {
          "num_cand": "U2FsdGVkX19LMNakqMDYIceyTe87gBuTWZM/RGku5C0=",
          "cpf": "U2FsdGVkX198Nhilds9qetQgHCvFaQLu7eY9qf8qxfo="
        }, {
          "num_cand": "U2FsdGVkX1+2V/6mVz5eJJunprswcfu1+wSRkRHhhYo=",
          "cpf": "U2FsdGVkX1+ppjOyzrSi40WFC5QFtyKO3uJ/yI60UC0="
        }, {
          "num_cand": "U2FsdGVkX1/lY+RFTKSVcWxPBOi5RiT9vUnqZDyR5vQ=",
          "cpf": "U2FsdGVkX1/TjGQqmO3AEgqkJ+CogZE7FfTjB2Ii8Ag="
        }, {
          "num_cand": "U2FsdGVkX19q9mnhGtRlWHaMwUr2zJVtimMnC4CgW3Q=",
          "cpf": "U2FsdGVkX1/6ndwYk1SpiGJ8m3/Y+VKY5Qb54EouFac="
        }, {
          "num_cand": "U2FsdGVkX1+to0UNXYRwNm6QU93T1n2gtbsSDX6GJNM=",
          "cpf": "U2FsdGVkX19wwohadDpNZZnDOWcgDo7FxMJZHin1PWA="
        }, {
          "num_cand": "U2FsdGVkX1/Ht2nGXIUVty7/3eLwKmTWQRWZaF9lxvs=",
          "cpf": "U2FsdGVkX1+5vw+u7JbYH1w1oGyabaKhfrhJUSa4bMg="
        }, {
          "num_cand": "U2FsdGVkX1/YviGYKmQsjcEp+KR+CwRaCmsLRwb2/yI=",
          "cpf": "U2FsdGVkX189Ikz/pIwm+55H9J/m2iySZsRmLECWO9w="
        }, {
          "num_cand": "U2FsdGVkX19jvYLhCrK84kAUkhmPeSbQY3ggqyWBgEo=",
          "cpf": "U2FsdGVkX19v39yUTVyR6QEzK/B8v7HFYMYHGyO880o="
        }, {
          "num_cand": "U2FsdGVkX1/ACBuU1hqZIMbTQbyT7zJ/dypnrTZFioE=",
          "cpf": "U2FsdGVkX19+phx728JXU1I5b/MiuDqal74pmxkR0q4="
        }, {
          "num_cand": "U2FsdGVkX1/A2H9Ol25mZZnl3Q6XhfaqofSRtY/DFMc=",
          "cpf": "U2FsdGVkX1+ISW/naKqZHsP1uOqJ6Gc6okDd/yyL6hs="
        }, {
          "num_cand": "U2FsdGVkX18QV7TRNOT8Iy9aCV/6ca7N7v+8Z1E5lms=",
          "cpf": "U2FsdGVkX18Lhw8+38urrZRK/yCaVKTnldXBvPhVXQI="
        }, {
          "num_cand": "U2FsdGVkX1/2hV8zjhSf9+m6XVlQE0bOUcolrMe/Ywc=",
          "cpf": "U2FsdGVkX1/gfmolEyVpE16XoQ92M58SflKZ7oFQyrY="
        }, {
          "num_cand": "U2FsdGVkX1/aqFY2IWyv+LqMJXlfSBlGrrl0095qmvk=",
          "cpf": "U2FsdGVkX18Z9IHukHH4p75R/cCt+fioIDqonqv2K+s="
        }, {
          "num_cand": "U2FsdGVkX18wo7Ty5RYJ4fT/x44t5ACTuJ1Y3b+LcNU=",
          "cpf": "U2FsdGVkX1+OA+uytHJcRBb7HSDoEYYJ0moXYtX7rnU="
        }, {
          "num_cand": "U2FsdGVkX1/1J+xlmyOnyGsHICqfKhG7SoKtiDMmeH4=",
          "cpf": "U2FsdGVkX1+1CG3M6FIGLwZAvDw+yOc952TXGMrSjq8="
        }, {
          "num_cand": "U2FsdGVkX19hSZRtKKvp8+tDFjxjg/6PP+l6dUFJe74=",
          "cpf": "U2FsdGVkX1+rOv9+HX8MTW3AARiGoYrqLTierrPGAdE="
        }, {
          "num_cand": "U2FsdGVkX1+FC8kQccB7bpkJD87SuACfPk4YT7Y7wI8=",
          "cpf": "U2FsdGVkX1/hK9FDeFmC19bc/r6hv43zfbZAhehTl6M="
        }, {
          "num_cand": "U2FsdGVkX18oh77Q+oBTUpiA/XEUjiDWDBIC8Fl+aeI=",
          "cpf": "U2FsdGVkX18Iz/DC1p5dKbHAGT87hzR4MB7ZA6Msm8w="
        }, {
          "num_cand": "U2FsdGVkX1+3j3c/CRKoFsVG7HLCQHPKAEfFbhjiWUM=",
          "cpf": "U2FsdGVkX18atR1Ll8e2GNmvWK6iQosyuYgAIF/8cnE="
        }, {
          "num_cand": "U2FsdGVkX19kn0xzOzt60HyO17lAPTUru9/s3qxJBk4=",
          "cpf": "U2FsdGVkX195UtWXU4gFLHsByR8BH0r5chZvze4hYcE="
        }, {
          "num_cand": "U2FsdGVkX18WD/i3FNW1OboHPU0kqKvoQ5bH5YZaKRU=",
          "cpf": "U2FsdGVkX1/w2QJG3uCa8gQd5mrr6LBVDqFCdHxPr4o="
        }, {
          "num_cand": "U2FsdGVkX18lbYAkyI/tmpDuZnSGsGPcphotFTkOSYs=",
          "cpf": "U2FsdGVkX192HujhqP6G1J8MxKcFlKg6LkNqQ7Upass="
        }, {
          "num_cand": "U2FsdGVkX19fUeaJSey5AsIVUI1nGq2UqfhzBSZkXjA=",
          "cpf": "U2FsdGVkX1+GzYBBfJktOgjLboxzMhQk5NhaQAhg6Yg="
        }, {
          "num_cand": "U2FsdGVkX1/1Kcl4lHf0PxD7NbJXaGBxxQMBtj6VC9o=",
          "cpf": "U2FsdGVkX1/16+OltxuUsXR+NmczK4+el8WCA+JSvbI="
        }, {
          "num_cand": "U2FsdGVkX1/6fTOvgUCP4Xwh8IGpdtEWMyhOQjoteIY=",
          "cpf": "U2FsdGVkX19aP1tf2kW55NgYcBMfH6KfbJpfMfpswso="
        }, {
          "num_cand": "U2FsdGVkX197ktvRR6W4xr5Ex07IJqUZr/tI4965Eyk=",
          "cpf": "U2FsdGVkX18rfiajKd1ZabXxqM0O0J13ZwwlIkMkH+w="
        }, {
          "num_cand": "U2FsdGVkX18c6NChYaHyXtXIM0Se6PxniNx7crmoo20=",
          "cpf": "U2FsdGVkX18QS3ryujSRYtWsbgNTHQHuto2zHykLPCQ="
        }, {
          "num_cand": "U2FsdGVkX1/cxdRXsFpCQ3SfL/+yKB5csOZuEhZkTIE=",
          "cpf": "U2FsdGVkX1/VbYknkV8kmJRlzDmY59yEeAZF39GnN4Y="
        }, {
          "num_cand": "U2FsdGVkX1/4+sb1aB4NI8p0Gg8/jMhcmZ8/mNx3ZiA=",
          "cpf": "U2FsdGVkX1+O6YxXBxcvJZzT5xdDOpQXPCXwqfvuHtQ="
        }, {
          "num_cand": "U2FsdGVkX1+RzdEBzbDpPSc3UdSUtkDznYaszgCOn3s=",
          "cpf": "U2FsdGVkX1+OmMregalatsej8CEUvy2UWDSnWDjtoDM="
        }, {
          "num_cand": "U2FsdGVkX1/gdln7+2NnnAyDo8veKY+RVEK7QrRDBYw=",
          "cpf": "U2FsdGVkX18L8LkO2S8b6TNLDwKt73U6ot0NQFXIROo="
        }, {
          "num_cand": "U2FsdGVkX1+g1dVDtNEhcpoJVGorymA0lf+rIND41aE=",
          "cpf": "U2FsdGVkX1/wxl+NNI/cg3uZ/5Ql9WRXAJ9WAxwCFPo="
        }, {
          "num_cand": "U2FsdGVkX1+l9XcDPQibvfIHokORRy/ZKHdNStoVWqo=",
          "cpf": "U2FsdGVkX18IJk1eTTfgd9y9mVxDMUhgUxwh3m6r23s="
        }, {
          "num_cand": "U2FsdGVkX19+KY/qo0wJjvxUkEsLd/WQ8f1UX26TeV0=",
          "cpf": "U2FsdGVkX1874WWWO+GevJ402oFOmiBUaoxwthHu+vQ="
        }, {
          "num_cand": "U2FsdGVkX18N/ur6lYImI2wU1qyWlFWtSBLsJBwGVCc=",
          "cpf": "U2FsdGVkX19VCz5ViHUVf587EiikAfEmfhClo+AICmA="
        }, {
          "num_cand": "U2FsdGVkX1+hQHEd0p00x9ytQR/T/gLyO4Fak+yiMHg=",
          "cpf": "U2FsdGVkX1/nw+ZskbzlnsYVbTh1dwSBboqGFX67ImE="
        }, {
          "num_cand": "U2FsdGVkX19IWFBvVSufDE4ystH3fmGHQUuBVcRn41o=",
          "cpf": "U2FsdGVkX19h+IYEVwfi7g4CuZiV1xbtJTuhQ4r330w="
        }, {
          "num_cand": "U2FsdGVkX19W5eHpH29PJfOhieLSa0pdZbJWkts22Yg=",
          "cpf": "U2FsdGVkX1/BQKupyCL6eW9C7kbggWIBGgGQ6HzeUmg="
        }, {
          "num_cand": "U2FsdGVkX189l5WvSM8lzVj3bObS2x8XH5C0DzQ6qnk=",
          "cpf": "U2FsdGVkX1++f72MBcg5TNBwqlUNxxwsMRRbpnSB2k4="
        }, {
          "num_cand": "U2FsdGVkX18ppgUFKXHBcJY5G/A6U3zlwxZhBPCijGg=",
          "cpf": "U2FsdGVkX19UK8/ZcRTeX/ZOSjMMdzu/EAAuZl9V4rA="
        }, {
          "num_cand": "U2FsdGVkX19KDoTqOePHHMIcoqXgS+0sciItZUDXoj8=",
          "cpf": "U2FsdGVkX1/rSfddjRdDjv3vOUbOgmN8yXE42IU0EFk="
        }, {
          "num_cand": "U2FsdGVkX18pQgB7mMr1/5PEhpQfduTt9QOXll5m0M8=",
          "cpf": "U2FsdGVkX19JOV1DH7UtJX411M3d1FnnW/4/4usOlBw="
        }, {
          "num_cand": "U2FsdGVkX1+62cQkEBI5VS8air6YpaPEeEeSJPUuEGs=",
          "cpf": "U2FsdGVkX1+9ZlydkCb/BswEgGQHPFxArklPBFELT/E="
        }, {
          "num_cand": "U2FsdGVkX18rhwcFZebSTLYyBq7PZTX7R96ahu3vgDY=",
          "cpf": "U2FsdGVkX19KsbSggoJzjjjST/+/0Rq49W0+SHSl/Sg="
        }, {
          "num_cand": "U2FsdGVkX1+pk9wDyghnkDDb+zTLjIRE5s6q0PZbLmM=",
          "cpf": "U2FsdGVkX18X2fBVwY3saH+jNKUrYEJfIMLbFo+dPwM="
        }, {
          "num_cand": "U2FsdGVkX18iycbfA9Bb2ZpTNSiPb0H1Bx51ddIxRgw=",
          "cpf": "U2FsdGVkX1+uVpmtSjPoLlhIc49jvDn8uRRdk4fO018="
        }, {
          "num_cand": "U2FsdGVkX19xjV6L/xKrgMTsu21ob99i0bvWG0FwSq0=",
          "cpf": "U2FsdGVkX1+xcWTlOt9Qs4kVhBEQEJXMZumE9rfiKGk="
        }, {
          "num_cand": "U2FsdGVkX18NEBGjePUo1Lni/aEVZnXEmWWqN6Zd+8Q=",
          "cpf": "U2FsdGVkX1+b51qUijc3Sc4gKs+N6Og+XIB1pTJUCaY="
        }, {
          "num_cand": "U2FsdGVkX1+moAdQQxT7rjRkS2thlNsYuQLHVZIz8G4=",
          "cpf": "U2FsdGVkX1/c0Xghty/YX1Apzhm3ymG9OPR8CfJsbNo="
        }, {
          "num_cand": "U2FsdGVkX1+4oIQe7qd5G4hdmPyG5HqMSZ+9FnKVs2I=",
          "cpf": "U2FsdGVkX1+SyrwYzEruRd2mtUYLbsDtUIAZbhTTCt0="
        }, {
          "num_cand": "U2FsdGVkX18XV+hJzMMnBmoR9vBcnP1OVBHgfcVnMxs=",
          "cpf": "U2FsdGVkX19V7FFf9JjAgEHcr12ZLvt/IM76wZbh7uQ="
        }, {
          "num_cand": "U2FsdGVkX181DQssAI/mDLVM5R33dlQ/KuDI6zykLRY=",
          "cpf": "U2FsdGVkX19d4o+rD61920vSXeV15z9i/qotV6zGeWc="
        }, {
          "num_cand": "U2FsdGVkX1+xJq+XEILlrxyIc+DQnbrKwB/7OEALY4Q=",
          "cpf": "U2FsdGVkX19KXKC90++xI+CjKVpw6rjTO3kBNZgQj/4="
        }, {
          "num_cand": "U2FsdGVkX19WhRkftbP8RtntAP1IIxLSujrmYbeOVFY=",
          "cpf": "U2FsdGVkX19FF0cKaUBYhKI14j07D1Aa1s+c/ARB/x8="
        }, {
          "num_cand": "U2FsdGVkX19UMLdPm5EIz/yMQ9FHn11oFteiAXsbkaQ=",
          "cpf": "U2FsdGVkX1+KdhTxRQV4lgkb4KMUZPjMPCTbGGoxsY4="
        }, {
          "num_cand": "U2FsdGVkX1+FOZbGwme67mvZDyqyfw4LarbsrynNzwQ=",
          "cpf": "U2FsdGVkX1/PkI66vBXkbqLBm+DuE38kop1nJ2vbTGE="
        }, {
          "num_cand": "U2FsdGVkX1+7FasAQvciJUV+gV4Sr1mTEf4y5pXrgw4=",
          "cpf": "U2FsdGVkX18Gysc20F0pDzVop8TZYBBNszoS/Sba9zg="
        }, {
          "num_cand": "U2FsdGVkX18sZ9B2ouwL2sElTMT15Dyyc+jsMrZUjOg=",
          "cpf": "U2FsdGVkX18QoMNWW4xr8wF2yxWBVfR/0Qrghj5tP8U="
        }, {
          "num_cand": "U2FsdGVkX1+wv1itA7N8u2I5zQ41LHdsgoAzXotlbvA=",
          "cpf": "U2FsdGVkX1924H7pESaoZ0obvYcT30IgOPoicvshQ60="
        }, {
          "num_cand": "U2FsdGVkX1+Axfs0oWI17o/yoFI2ZhS1iCoqF0ddDf4=",
          "cpf": "U2FsdGVkX192RnVxOIIMxANYV4F6wjvQbuyAD4+0sYc="
        }, {
          "num_cand": "U2FsdGVkX19l1XuBsYXgOuM8VpWcM5ul3sCX9DcAwno=",
          "cpf": "U2FsdGVkX19YY7bQNWP0FlTs3F5CDl35/zxkCc/n734="
        }, {
          "num_cand": "U2FsdGVkX19k7ZRW/iUlkk6cgetBWwgUOuvZmHb/5XQ=",
          "cpf": "U2FsdGVkX1+8AXOg8PbIUGPZfATqDXrTUBcHg+2r4og="
        }, {
          "num_cand": "U2FsdGVkX19LJWImbCiAJrbKUrGCGU/wy+4w7FzuP1I=",
          "cpf": "U2FsdGVkX19HzeKpGxnZ+np/JgZEcqkNH9fYPVXPAIg="
        }, {
          "num_cand": "U2FsdGVkX1/mEsqXXQccizeSsLc+wFsUlRPcQFuTnyM=",
          "cpf": "U2FsdGVkX1+ZbfIZDjZPPZsQ03LctgGvCSrDR1K/rNo="
        }, {
          "num_cand": "U2FsdGVkX1+1Ne3QDQ4qU/cWceoBsCGE1TkHO4LjPts=",
          "cpf": "U2FsdGVkX18X4Kzu6rcBqLd1J4zRKs6Izh8uvRPTwx4="
        }, {
          "num_cand": "U2FsdGVkX1+ZxxTvSc3s92E+ibnpjyxfaLYqws4va0o=",
          "cpf": "U2FsdGVkX19ik4PU9xYr7U1SKo+RuzFTdIwvJwkaQyM="
        }, {
          "num_cand": "U2FsdGVkX19SQ1en/eZ2/2W3ErGM2reJ1B5mMxPTNWw=",
          "cpf": "U2FsdGVkX1/ep/JdEHVMZD7M1lPHmyfiCTLIRMzO0hc="
        }, {
          "num_cand": "U2FsdGVkX1/EfgMWgGcAABbW/QlZRIAOpRLhZP2HHIo=",
          "cpf": "U2FsdGVkX1+a9OIXu9dy6JE+Uruab/Udk0vBZjRO8Ek="
        }, {
          "num_cand": "U2FsdGVkX1/RWPM6e6tAR84f3igO1lJ9TIgbzIsgJao=",
          "cpf": "U2FsdGVkX1+ApS86auG/YDZdJy0auWq8Yl/xqeFhB30="
        }, {
          "num_cand": "U2FsdGVkX1+pJksv1vjHwAsocRJE5y5I4J25veaSQjM=",
          "cpf": "U2FsdGVkX1+qoEOkza6gU2mBtyeaCp2IMmMfX3gDWKE="
        }, {
          "num_cand": "U2FsdGVkX19l0RX4KxcrGh16bguxv60R+onIe/uN9NM=",
          "cpf": "U2FsdGVkX190HwM/GM7m24CmgLpGB8+7ywYyAnax+Sc="
        }, {
          "num_cand": "U2FsdGVkX18Ei4C5dEj7xyzLFtfrHKs7fw9oJtD4fNk=",
          "cpf": "U2FsdGVkX18KU00QrNsmG9klrE13qg3vKaDYaIrCyEQ="
        }, {
          "num_cand": "U2FsdGVkX1982F79FyZFq7FInMd1Wdr3nMMR+bbpCsc=",
          "cpf": "U2FsdGVkX191gQl9131+pnAbweN2cGj+U49FaTAWRa0="
        }, {
          "num_cand": "U2FsdGVkX1/ME6p40xXnvjku0tAAEJ255exmVKEJ0t0=",
          "cpf": "U2FsdGVkX1/CNZgR2S9In0C+xjRHP3BqGZdE3eVNbMI="
        }, {
          "num_cand": "U2FsdGVkX19rVMiKcNoEPrt2GyWTEPy7kGRN8HJrjHo=",
          "cpf": "U2FsdGVkX1/s/mKIMe5ieFp4Hu09q4YmoyAaa3bsnuY="
        }, {
          "num_cand": "U2FsdGVkX19a6QAA7RLbyJQRcOsBLrKDktApullOJqo=",
          "cpf": "U2FsdGVkX1811BvqSMfyVDAM10ygYyMEKUpShNZVMcs="
        }, {
          "num_cand": "U2FsdGVkX1+titnwzB1oh6ztFLyZPv7AyfGP3cDGHfM=",
          "cpf": "U2FsdGVkX1+MDEanFVGcac0ZgMBu5HrGoSMBhAbp+A4="
        }, {
          "num_cand": "U2FsdGVkX19CPa4RBviSy3D2Fx1V6u+jnWWmpbEE03g=",
          "cpf": "U2FsdGVkX19pgkRCa9706M3pKkzvt/HxAj6G/AArZBM="
        }, {
          "num_cand": "U2FsdGVkX192bDO7kNRySv8HehEzEEerCg8V03fJP/8=",
          "cpf": "U2FsdGVkX1883RaFCE4orlp+W+ClUJCT1LOpUzzag4k="
        }, {
          "num_cand": "U2FsdGVkX1/hwiz/lN8C/F8PL+h+QEYdCk1zTn1Hocw=",
          "cpf": "U2FsdGVkX19/W0R0GqHyGZV/Rs529JbWrBcOU5MN0kE="
        }, {
          "num_cand": "U2FsdGVkX19cAZGqFPBQyVxvv+Q8O+L4cIftCL+XXJg=",
          "cpf": "U2FsdGVkX18X9ajf9/cnkoA++D+rxBXBcy+yHqpPaBk="
        }, {
          "num_cand": "U2FsdGVkX1/Gs4CbR90A037icJUupp+H5veXj1UgZuU=",
          "cpf": "U2FsdGVkX1+dVTHEbVNgGupmmuWYVvSLSJT4zRhIbjg="
        }, {
          "num_cand": "U2FsdGVkX19WD6HgW9ATYb6KoFP717tYyBZtAmvEVBM=",
          "cpf": "U2FsdGVkX1/18QgEdL0JdlHnIcR5p4TLlqFGIAG68YA="
        }, {
          "num_cand": "U2FsdGVkX19+z6XEUvs5/b3zGhIJYkVOTPxfkCfxjAk=",
          "cpf": "U2FsdGVkX19yyutlgAgquGxQof5MzJhGxij+2vwnwaw="
        }, {
          "num_cand": "U2FsdGVkX18Ujuz7HppEL1mJ/bBWuB2dBQqZCxCRHFg=",
          "cpf": "U2FsdGVkX1++Cg9MFDjmAOBUONlcJnAXiDmtY8IkN5g="
        }, {
          "num_cand": "U2FsdGVkX1+6Kz9qTVYFQbLwPzX8zyH4BIymU3Ahg2Y=",
          "cpf": "U2FsdGVkX1/QCFKIighb6dhSpWIiQxBtKhYgdN0XsZA="
        }, {
          "num_cand": "U2FsdGVkX1+nzGR1svJ2iG0hYIfGPy0Ggh+5axX9LbI=",
          "cpf": "U2FsdGVkX18FVFrHaPQWHKtwAJpNuWxpHYExWOZkUKc="
        }, {
          "num_cand": "U2FsdGVkX1/Oii0nyx4MYssl8uxNJCuICbwKnglBlY0=",
          "cpf": "U2FsdGVkX1/rloK0psgNFaepD5kh7jV50lU/so8KX9g="
        }, {
          "num_cand": "U2FsdGVkX1++qAl1NI4NLp50qE5DVnpRHx5s5qP+IrE=",
          "cpf": "U2FsdGVkX1+K9u2WSVmKm/fA3epD7Q1z0PpokeF3tc0="
        }, {
          "num_cand": "U2FsdGVkX186VyDSvIpZHHpFtPHc37CfZvWkuqZ6qaY=",
          "cpf": "U2FsdGVkX1/99m7z9L97XLSVCrsLxcqGTNJORubFaHg="
        }, {
          "num_cand": "U2FsdGVkX1/fvACf7YF8tkOeSHXT9Ga5l+mTd0EX4pM=",
          "cpf": "U2FsdGVkX1/rWQou/1vuEtkKC/x0+HZw+0ceZvIpGQU="
        }, {
          "num_cand": "U2FsdGVkX181jjSI7pPo00HvrbwbZEoHS0ZQfdrN8qQ=",
          "cpf": "U2FsdGVkX19GIksctjK/yyQcNf2il22C4IgAPlu2Wl0="
        }, {
          "num_cand": "U2FsdGVkX1+Jew1uRVzrfbTw+ciFa0/T7G9iLHAIu3o=",
          "cpf": "U2FsdGVkX1+ji6hdRJVDd/C15rYjF5m88CKpSx56tlo="
        }, {
          "num_cand": "U2FsdGVkX18i5o3a54FBGU2xK70a/GMlUW55BGHfYmU=",
          "cpf": "U2FsdGVkX1/NNvDM+gx/xQB58AR74KU/RmXvY36Y1ZY="
        }, {
          "num_cand": "U2FsdGVkX1/Amavvn9cVSf7KOxAyYTEFNdt96o8BSjk=",
          "cpf": "U2FsdGVkX1/802l4/avUvq+luX9JRcmvTdp8CH8hfGI="
        }, {
          "num_cand": "U2FsdGVkX19X/blHhHsxYT+lcsdJmHbHqDLePVjRE1o=",
          "cpf": "U2FsdGVkX191SJST3LC57LzjyfCSkP29MDNczNJkOos="
        }, {
          "num_cand": "U2FsdGVkX1+huTBOrjDfagGZqtOC1PUsKUhqPtYY7F0=",
          "cpf": "U2FsdGVkX1/s/33XBN+2tLpYywLbzYRtpNGsxw6KxWE="
        }, {
          "num_cand": "U2FsdGVkX18/8gpqahSYWzmN35ZBrqjRBJEK6JS3zuY=",
          "cpf": "U2FsdGVkX19/Q+elxbBoUuyFFjHRZh6kgYhwYoF/s+I="
        }, {
          "num_cand": "U2FsdGVkX1/CCFDgR/t/Ez7MVOD+nLObfNKymZoHkDY=",
          "cpf": "U2FsdGVkX199Z4qofB/WAh3uxmvPC8rvok2PmE1SjmE="
        }, {
          "num_cand": "U2FsdGVkX18zePOKGBrt5V6ErbCT0qU7jsI9LJbLxgI=",
          "cpf": "U2FsdGVkX1/7dy1BXoebX4qhMx5Jz+cS1q2C0Tg1zAU="
        }, {
          "num_cand": "U2FsdGVkX1/YgkVMkoBRTD8BS/HcnyMiQTV+30yEtYI=",
          "cpf": "U2FsdGVkX19vQs5b8A/kzi5OV+8B58DjQ6TfVvpSflI="
        }, {
          "num_cand": "U2FsdGVkX1/F5CDW8upoSq+G0hyOV/c57tlBBcf+Pak=",
          "cpf": "U2FsdGVkX18WIC30wNioYVfNAlWwxkC2ImdUainc0pI="
        }, {
          "num_cand": "U2FsdGVkX1+QdPJ92nSKmJmOUAj3dpV8MzUXazuQf0M=",
          "cpf": "U2FsdGVkX18ZRXZrK/4EJpt2CzqClf9VdqS9erHbTyw="
        }, {
          "num_cand": "U2FsdGVkX1+6+Kg/6+zhMGHBXqQWK2ttB4uUReas2Bw=",
          "cpf": "U2FsdGVkX19+Lk2Bw/Y9+dbJEVLrkd//ZRRcE7+++ls="
        }, {
          "num_cand": "U2FsdGVkX198K7I+9zUT9vd5l5NNB2uMbeO658JEA5Y=",
          "cpf": "U2FsdGVkX19/YVBgQsX8z6RRGMPcq4OoJHf6SVycvrU="
        }, {
          "num_cand": "U2FsdGVkX1/FdX+YdP776U6Al1NG6OoVzI/QjTHTlLI=",
          "cpf": "U2FsdGVkX1+9O428+jCBzTtmt/Ze3MPcLTimKRC8F8U="
        }, {
          "num_cand": "U2FsdGVkX18KKHlZTEScoN6/pOzve8j4JT4ArageQrY=",
          "cpf": "U2FsdGVkX1/awcc/xwuvESeD/lmRxAP4nzDunvaOEZ0="
        }, {
          "num_cand": "U2FsdGVkX18bXyliRt/YVPFvnU2iY/Yr28a7ec99MM0=",
          "cpf": "U2FsdGVkX18GFeypdnnGiqpOEJeyL7XOwl888W086jM="
        }, {
          "num_cand": "U2FsdGVkX18rfXMHXhCyN40NfBsZQ0hSVFx1t9qyv0M=",
          "cpf": "U2FsdGVkX19iUpxeO7xnYIBc4uujBFXmvjTDqmS8Vhc="
        }, {
          "num_cand": "U2FsdGVkX19+8e2Am5xIkt0Whyh2VMvnSHU7GMeb/qg=",
          "cpf": "U2FsdGVkX19cZLlzNkbyL4IGM3w7cLZfUo0nnYPyOmg="
        }, {
          "num_cand": "U2FsdGVkX1+uX+dfprfFMgjMdMuimhIzNzFL6+dtwWw=",
          "cpf": "U2FsdGVkX19qnVz2mEGnAhYYZoj135pcZaQ/myIPJgI="
        }, {
          "num_cand": "U2FsdGVkX18KdnBi5MN50/WYeVjk/n3vdVQbnXplBD8=",
          "cpf": "U2FsdGVkX1/Hx7I7dipCCX1hSw6Lrtr3oGWj2QNsYos="
        }, {
          "num_cand": "U2FsdGVkX19weRFU64dSwwcaRHiPHnF5TrCPNXNLfE8=",
          "cpf": "U2FsdGVkX1+g7I1wM5hcq1Hi4Sm5O2xYdvz0lhM9DLI="
        }, {
          "num_cand": "U2FsdGVkX1+2uG6cXU6NCnMFQ0tJzRrSRTWGGpEaRFQ=",
          "cpf": "U2FsdGVkX19Tskxr1XtJrETpCt4TxsSv58Ci0bzDh9E="
        }, {
          "num_cand": "U2FsdGVkX1/Ar3vW7HLhdxCTPp5HMWU/wHB+RUFBJYM=",
          "cpf": "U2FsdGVkX18zf+ad4+cCL5SXQH3SGNIb+ZeJkcMYZ5M="
        }, {
          "num_cand": "U2FsdGVkX19I70dbQt4I+vrJx5ClfCh5mvloXX+Vi8s=",
          "cpf": "U2FsdGVkX1+mIeMgMAx5SCeHdubqGiyfAvXORR5eQc4="
        }, {
          "num_cand": "U2FsdGVkX19GKfCDRMra3j5aZUU2LGdW5GrQJAZ1+qE=",
          "cpf": "U2FsdGVkX19SMA03d2PwOdRBNdaKLuAcmknYsZKH+YQ="
        }, {
          "num_cand": "U2FsdGVkX1947hlzHYxmr3/LhdlqQC6CZpNSTY/x8PM=",
          "cpf": "U2FsdGVkX18IuPc793AH88cLgIPD8GaxVTiHtyWWRxY="
        }, {
          "num_cand": "U2FsdGVkX1/LwgrKxdWhoT7tcFcDCnw5QZgHRg5bI9E=",
          "cpf": "U2FsdGVkX1/M+Dfou54PAdEeQDDxEFHJ2kLu1e4gDW4="
        }, {
          "num_cand": "U2FsdGVkX1+aX43aMtJzaT4zBrd11U4B2lxUL9ixuKE=",
          "cpf": "U2FsdGVkX19Ex6oqsIdA8xl8IYYXqbvqv+poDyHawDM="
        }, {
          "num_cand": "U2FsdGVkX1/dD+nM9C/Qafl8FV07DCp4b0fiHbgDtMo=",
          "cpf": "U2FsdGVkX1+vSDpCktj3UBEyps8Wzj05b5sGzcdDZuk="
        }, {
          "num_cand": "U2FsdGVkX1+96j6SvFkKAL3AuJtkN2OqVMfUwMmrDnw=",
          "cpf": "U2FsdGVkX19rEWZT9udlUSJEEIPVwbKTjP6VqTWE0Og="
        }, {
          "num_cand": "U2FsdGVkX198mIm2A+LT/Lo7qTuIcg9235rjKRI5Icw=",
          "cpf": "U2FsdGVkX18X5UrQDXGLM8T6dUoCbkOnqeqNsf1JxHw="
        }, {
          "num_cand": "U2FsdGVkX1+9V6YijDocdJm5/cbQTPL6i5i2/WCY8J0=",
          "cpf": "U2FsdGVkX18d17sSaePfWdPWgv0YVUdDNHiBGyJkUTk="
        }, {
          "num_cand": "U2FsdGVkX1+caFbkCNkpLFSF0tNwpRnB65UhSCHX6VI=",
          "cpf": "U2FsdGVkX18CDkkB9Fc+1D1OhvDk/+9K7DXjYC5Nl2g="
        }, {
          "num_cand": "U2FsdGVkX1/+cTk+brlr3iHUYccR58R0qHcGGQIPqBc=",
          "cpf": "U2FsdGVkX19VB9B7IvubwVVazX9bZp7jW49nD+D1++M="
        }, {
          "num_cand": "U2FsdGVkX19jA2x2kcXMWnWtjJJjn/mepYOVjDnxiLw=",
          "cpf": "U2FsdGVkX1+gx8LcMyCGnLox4tUUJmqzr/3JJRH69Ik="
        }, {
          "num_cand": "U2FsdGVkX1/Oe3EAYUMgkEByZ61aJ5VCNVS8zmpHJ1Y=",
          "cpf": "U2FsdGVkX18J1nSofBzWrBuUAZrVjJHnRIOI7GafXts="
        }, {
          "num_cand": "U2FsdGVkX1/Lj8AxWwFhAZVnQhSr+yLwJH4H9Z0E+wo=",
          "cpf": "U2FsdGVkX1/RsEboH2mwusVJRErZIj/vjjlZzJ7hulg="
        }, {
          "num_cand": "U2FsdGVkX19iOct4oFLv8Y9HScLBtdqPpAAzQwXZ6Dk=",
          "cpf": "U2FsdGVkX1+i9x2YkV9wtaz8bJ4e+WQN3oaUO1S+SVc="
        }, {
          "num_cand": "U2FsdGVkX185FJm3rcwv6diBYhGQWSwfTadM/TgENuo=",
          "cpf": "U2FsdGVkX1/fO2+jq/JwBS8/jY9nszBHlqPOhfoCnNg="
        }, {
          "num_cand": "U2FsdGVkX1/u/5AKM3ayEFBLwWi62zeIs3996uf3Sy0=",
          "cpf": "U2FsdGVkX1/a6hgUAFWd0Oya2fI5ApJR6QYiqo0ZGEA="
        }, {
          "num_cand": "U2FsdGVkX1+JBNR3dHVbLSUqT77Trzgc/uw6jxa2J0M=",
          "cpf": "U2FsdGVkX1+pWbpZxPAHLCFEwzYeT4df74H2Raa/aH0="
        }, {
          "num_cand": "U2FsdGVkX18Fo9QLzV/FQRTNvye4PfHwWJUv55/BniY=",
          "cpf": "U2FsdGVkX19n4xoFFhGZmmiB82NHs5TTv1EGxoafgRw="
        }, {
          "num_cand": "U2FsdGVkX1/MAujPoLsIEgj86CQ5/DOABpd24b1LEY8=",
          "cpf": "U2FsdGVkX19XChcekUfjdurQiid3ChMiimIaVjj6GrM="
        }, {
          "num_cand": "U2FsdGVkX191BO9nJbYK/lU429dp9RL9fopiXpbCnA0=",
          "cpf": "U2FsdGVkX18oA/rdXmw4YbIIpuPnfSxltQzC7C874zk="
        }, {
          "num_cand": "U2FsdGVkX18Y0gplwj1ALsHUdPH70iU/Ygv7G6tFpIY=",
          "cpf": "U2FsdGVkX1/kU8uOZsmpD8VgNLfmD5j1+yXumEU0zjk="
        }, {
          "num_cand": "U2FsdGVkX1+z422DU7FHuuWOnDdPyIwXerJ5eeaYgmM=",
          "cpf": "U2FsdGVkX1+ON9yYJIVC3Hq1f/YmnpKg7Yug9Rz8pFs="
        }, {
          "num_cand": "U2FsdGVkX19SGR9/3m0nYCPVG25dpIr/rMs39hozNFo=",
          "cpf": "U2FsdGVkX19rK6gzwLhRWxq0K3GaVNU9KL0AXCMsP9I="
        }, {
          "num_cand": "U2FsdGVkX1/RnutlQdSIZeTmmdjfr5J4mC6e6bUExDY=",
          "cpf": "U2FsdGVkX18n4inU2DCFT/CznRDnCrateUJNO+U/5lI="
        }, {
          "num_cand": "U2FsdGVkX19huj6v5ZkPObply8KTNEzIVWnuad8mSxY=",
          "cpf": "U2FsdGVkX1/0nIWq565UDAcDtAe6CGOUo/iEBNskPPU="
        }, {
          "num_cand": "U2FsdGVkX1/PmptNkIQ4lFkG5X9JicWeffEJXllw/t0=",
          "cpf": "U2FsdGVkX18FSdRoaXZuNsn7g6UxHX1mPNCGpOTN+RI="
        }, {
          "num_cand": "U2FsdGVkX18JDx0i9JMg2cHWs1+KBKM42++K3JWHYH4=",
          "cpf": "U2FsdGVkX19ISywu6JvAb266rKfgXKf9FfrYx4X/abE="
        }, {
          "num_cand": "U2FsdGVkX18LO2JQ3+Iuqq2N8wKnRrj5uCesEaE+Q44=",
          "cpf": "U2FsdGVkX1+ywzcrFn2bVnIMl2cTlQOT7eG3x7AD3RY="
        }, {
          "num_cand": "U2FsdGVkX1+MTTnSF6FqhghUfyajX+QyB7aqUODiPuo=",
          "cpf": "U2FsdGVkX18M/Ht8VIiSn2P2hAyaK/GGfBQrnNaIqfs="
        }, {
          "num_cand": "U2FsdGVkX19mWJT3IvhVpYjbdHHAcUpTrh9wrbcxqog=",
          "cpf": "U2FsdGVkX1+jV8a6OBUvTHAYr4jKv8fQhLbwOyT8wdA="
        }, {
          "num_cand": "U2FsdGVkX1+wBn8GGaUXUkxv0C5dFKJi7iIwoVoCYZs=",
          "cpf": "U2FsdGVkX19fxC3So6L0ES72ADrV5lBnwHlnODPB0Rg="
        }, {
          "num_cand": "U2FsdGVkX199zlRcGChc4i57lbx365txksUNhHV8vYY=",
          "cpf": "U2FsdGVkX18g8ndK3jdI672Pc7/qTAZdCYmhgBWcRn8="
        }, {
          "num_cand": "U2FsdGVkX1/i805OJe02h5kNtWnzjEa/H2ZX4jEo/ek=",
          "cpf": "U2FsdGVkX18/svHMNsMi1FzXeehjT2JzUhyDeA/+Pgk="
        }, {
          "num_cand": "U2FsdGVkX19UY4M2JadU/1p0YZ7ypnpUyasP51bnzsI=",
          "cpf": "U2FsdGVkX1+7UEMrk4SL7hq+SwzbkiitTwozDCOk3w4="
        }, {
          "num_cand": "U2FsdGVkX1+feTQY4sjgXwhuDtHimPgwPJBNgHHXTgs=",
          "cpf": "U2FsdGVkX19rvc/F8o8XeKxvjVW3OATLAc7/JbbgnbU="
        }, {
          "num_cand": "U2FsdGVkX1+SE8tb6+BH3o+AcGW2JBMXlhIyKg9qZKI=",
          "cpf": "U2FsdGVkX19ZYdYpq5o+St/2sxuS28LM5KMKaG1y4hY="
        }, {
          "num_cand": "U2FsdGVkX18G9NZUQp8bqvrsBBylqnFsezkUrobkF9s=",
          "cpf": "U2FsdGVkX1/Rul0oW1VYYj7OpzwHujDpAdRSnUzpWC0="
        }, {
          "num_cand": "U2FsdGVkX18Up9J0NsbVV0NRBKKdxYuQXpzoL4Zsv/o=",
          "cpf": "U2FsdGVkX18PEyB5rAIFLGmmzS+EOOa34sMvTr2BaHs="
        }, {
          "num_cand": "U2FsdGVkX19gwnYcPQTHM0KMl8V/bzGVX8jOA/p9GYg=",
          "cpf": "U2FsdGVkX19YsS6l/PLYVLzOggXnTkbeoz3S+eOlqt4="
        }, {
          "num_cand": "U2FsdGVkX191vBdn4bqjFC6aOjcNZK9tbeIMkRugdyQ=",
          "cpf": "U2FsdGVkX19hCoe9knSki5EUGPYDRAgc5/AskC8HASU="
        }, {
          "num_cand": "U2FsdGVkX1+TqG2DpOmVEe6J4mPZM6iPe2MvnaIjhzE=",
          "cpf": "U2FsdGVkX19DEF6V41rkfzsM9QSaMIyCKvkOh7PZJ8A="
        }, {
          "num_cand": "U2FsdGVkX1+G46mRiNtw9XXbXwCh5IGeMlaMa6bUG2U=",
          "cpf": "U2FsdGVkX18zpwJWy023PuJi9pl9gvB16caToAZ7z+I="
        }, {
          "num_cand": "U2FsdGVkX18wFInSH89y3GlQTYJ/XBWi2h6EWuzGxs0=",
          "cpf": "U2FsdGVkX19+5lbRPhW79po+RJX784GI5j0tCzPEIGI="
        }, {
          "num_cand": "U2FsdGVkX1/um0f7xA72FfF2wIbe3r9sx7dcDS+jrEM=",
          "cpf": "U2FsdGVkX1/hX746XVlW3T2iO4x7lwj1ji0pxJ6816k="
        }, {
          "num_cand": "U2FsdGVkX1/WttL+Pl4TZHKhl5kjzXqbCcOzg3rgQVM=",
          "cpf": "U2FsdGVkX18HCBP6Fqok5YNkXfePhX+A/VjU1xy38b8="
        }, {
          "num_cand": "U2FsdGVkX19GkyhUykdKNVjBQF6PdOAsuCyNIErbzwk=",
          "cpf": "U2FsdGVkX18IbF2Wwj1jZeBTdOF8wZ1UFumIucqak/E="
        }, {
          "num_cand": "U2FsdGVkX19FJuv8YxVW3BRcBCf6PjGpDcaU+HHJpH8=",
          "cpf": "U2FsdGVkX19rLGUDJDYD9R0EnUdbUnP24hgBMpbF+lc="
        }, {
          "num_cand": "U2FsdGVkX1+BNsVoZFpYCWIY54Ly0eRvJFXM1KGZido=",
          "cpf": "U2FsdGVkX19nbmi+Mf9w+1Pa7AUwclPJ5oYKCX8f0OU="
        }, {
          "num_cand": "U2FsdGVkX184Efr0cjK7B5wre6yRytL2gSC6XQxKVok=",
          "cpf": "U2FsdGVkX181AwzGRfZ6CGivnYUAC46sDyF5NCFbTr0="
        }, {
          "num_cand": "U2FsdGVkX18LflkTaNyfJntm0iwKkHyrqsed4gKOlH4=",
          "cpf": "U2FsdGVkX1/gGdxZgF2ZQitdZQE446X6dtbH24AUdqg="
        }, {
          "num_cand": "U2FsdGVkX18CLB63dHrtqUq8CeAyxlY3ML2qIbC1CgA=",
          "cpf": "U2FsdGVkX18b5bu5lR8D4/mSJaEpY+7a8MOzsZH0uM0="
        }, {
          "num_cand": "U2FsdGVkX1/eABMMBL/+2NQDReag0QSdez2e7Qr1i1M=",
          "cpf": "U2FsdGVkX1/6GbeQtKoiskTt78gqZfxe6r6y56cCJFg="
        }, {
          "num_cand": "U2FsdGVkX18rmUek6eYiRdMfXzNtVKgWESY3zIsUGgE=",
          "cpf": "U2FsdGVkX18iob5WItpSqSnDhZPB4qDUxV1g6uV2hvs="
        }, {
          "num_cand": "U2FsdGVkX19sSBL3RYxVW/KCJuLEHar425QVriSF278=",
          "cpf": "U2FsdGVkX1/3TR12kqNx1Ms+3OtnV5GyaUAc9wHIWcY="
        }, {
          "num_cand": "U2FsdGVkX18F10mDLuYgXGDSuKVCfhqbgRTz89E/OCo=",
          "cpf": "U2FsdGVkX1+KkBJvpkRs2zyt+MuSqSgJq4VdEXG+tck="
        }, {
          "num_cand": "U2FsdGVkX19qDvqv290YKjBP912lVX+vP7I0DOazuSQ=",
          "cpf": "U2FsdGVkX192UWq17xZfPicj2yYIefqIM4h0aj6k3fY="
        }, {
          "num_cand": "U2FsdGVkX18zvhBA9d6DvdFbFpc00GphfabPwJM5kJ8=",
          "cpf": "U2FsdGVkX19c9r7eH7W6VOm6ku+LBHgjW3Vbl0+Ovvg="
        }, {
          "num_cand": "U2FsdGVkX1/iPFArPAkFxvX6V24o8CHDIKy6ZkKd/Cg=",
          "cpf": "U2FsdGVkX18fVKJRTszqWW1kAj8NZSdcxWKM42eLf6c="
        }, {
          "num_cand": "U2FsdGVkX19WaVWLVnBM0caDkMOATPZ9SiGh5TYHZKQ=",
          "cpf": "U2FsdGVkX185cSKOgWYu6hoeYNlM3ryATRMTzo9wxYs="
        }, {
          "num_cand": "U2FsdGVkX18ZuH1v5XlNKKTtPN/3E6ZWbgIVZ3deEKw=",
          "cpf": "U2FsdGVkX19Pc28cdExFTVnIU7lK7ysQ8VJNpbHP8zA="
        }, {
          "num_cand": "U2FsdGVkX1+Sxyv/4AHyKjL/FvHscfqML8dkJ+vVbCY=",
          "cpf": "U2FsdGVkX19aGO0I+vgO6+nBdTaCakc5dzbslDRiSZU="
        }, {
          "num_cand": "U2FsdGVkX19s9HxSF+5hWlWns0+QW3+5sTPz3jUEY3o=",
          "cpf": "U2FsdGVkX18BArzEU3QHLZnLvVf9jb3RyYwlRARl2r8="
        }, {
          "num_cand": "U2FsdGVkX196cYZ0bZaHuN2AyPKd3HwuvfGZKgAlYNc=",
          "cpf": "U2FsdGVkX1+0zVPNHpkHZ9TIqT5sX+l9rlreLNfn5gU="
        }, {
          "num_cand": "U2FsdGVkX19u5pNWTLaX80NsL485JOp04ZMYxcyCTsM=",
          "cpf": "U2FsdGVkX196WlTrE6hTaCnQxl3VTlEWJqXHCAGOuXY="
        }, {
          "num_cand": "U2FsdGVkX1+GzhJ+jWZi/XTELbGy9xy7AdVSoD9mY4k=",
          "cpf": "U2FsdGVkX19KNSsQyCV7E73kYSzMzTLuaeuEyYPw5Xk="
        }, {
          "num_cand": "U2FsdGVkX18kSBG32CkJXDkurSXSTaYIGFscBI15NuM=",
          "cpf": "U2FsdGVkX19aNB64OKyl+k5KfjEjA+6be6nwN9KyRsU="
        }, {
          "num_cand": "U2FsdGVkX19RVb7KOEphe5YmCry77PNmCGignweDp94=",
          "cpf": "U2FsdGVkX1/u0P9qIMIvXROJD80ND1o+RCe6dCyQL8s="
        }, {
          "num_cand": "U2FsdGVkX18Sh0UcW5+Sdf/L9il/3eMTCr4KC7/zANs=",
          "cpf": "U2FsdGVkX19J+ustQSIL/Ocg7mavW09Kl17dMzugfj4="
        }, {
          "num_cand": "U2FsdGVkX18pStsxGhiBAUUCvdLLFH26EtS8Nk3Kjmc=",
          "cpf": "U2FsdGVkX19knTXLsYjpTKSF57BqnaR7bfwR00e9nfY="
        }, {
          "num_cand": "U2FsdGVkX1/jv2gPZj2Jp1vXaXPKrjZapaqme/ly5X4=",
          "cpf": "U2FsdGVkX19gU8d5bgDzdNLkFk1RaD4dw7e7smrqbbM="
        }, {
          "num_cand": "U2FsdGVkX19Lp/jrvUOVnrdOxx32EUqgm+BonB+IbHE=",
          "cpf": "U2FsdGVkX19tn7teNg4pN0IrMEmy6J1MxadlGsUbdSU="
        }, {
          "num_cand": "U2FsdGVkX18jw9/yDOdbS7XdwgPjfC0BWbjcz1IPWqM=",
          "cpf": "U2FsdGVkX1+lNRkfU2POTqfHdblU8CRXWCfrSgoaclY="
        }, {
          "num_cand": "U2FsdGVkX18h1+axe0C5XPVHqSMBqfiEq0WnvX5rVfc=",
          "cpf": "U2FsdGVkX1+Lx8ZUHZWHtFL30LkavI9bijN1R50HO0U="
        }, {
          "num_cand": "U2FsdGVkX18WeUdlmGWDIWtI0OX4I1JF99p6N8II8tQ=",
          "cpf": "U2FsdGVkX18fW6c/O1G9tHxXrpNtv48kRz4zPAEN/w0="
        }, {
          "num_cand": "U2FsdGVkX19xnN8MkLyjFrldeqUh4fSZNnr2s+xa+gA=",
          "cpf": "U2FsdGVkX19gaQuEPNxO6zr/Bf0njsjP+I5LSTcUUZk="
        }, {
          "num_cand": "U2FsdGVkX1+oaz1hAv9iAWYMKCjIMfrJqtON7GemQj4=",
          "cpf": "U2FsdGVkX1+3qbHR0cpgZBHJnHAu0GvioZn2yfvC70I="
        }, {
          "num_cand": "U2FsdGVkX1+t9U2vYebdg35eVGSmD+SUDN3O7drFWdI=",
          "cpf": "U2FsdGVkX1/n493FsyenM8vTQ/VpWQk0lq7cX42TGpk="
        }, {
          "num_cand": "U2FsdGVkX1+lx63IsJsvpR1LOEB4sTJ6luyKxnnz2lo=",
          "cpf": "U2FsdGVkX18pha6i7naQD6mQIHcKHl1bo9Way03QbxM="
        }, {
          "num_cand": "U2FsdGVkX18KbDV9dOtyGRLXM5Em1HYQAhuO/66szkg=",
          "cpf": "U2FsdGVkX19U1LY8sEhDos2Yxc8O1nbMjc5yf/p89n8="
        }, {
          "num_cand": "U2FsdGVkX19gyzt+fDMVcdiGoBIDN3zSqiScAPpRcoY=",
          "cpf": "U2FsdGVkX1+ptQqipnLgk6UhldQ0BO5tpYOFMohpxmI="
        }, {
          "num_cand": "U2FsdGVkX1+Q6LYvLCs40Ml0Ty3lXYhqHbv5bP79YXo=",
          "cpf": "U2FsdGVkX1+GnMk/fdjtQyfz3X6XpTPLo0RV8UEWJwE="
        }, {
          "num_cand": "U2FsdGVkX198O1jXkKslYEiSh0nQGGbPNf6EFwtIpVY=",
          "cpf": "U2FsdGVkX18GIe3X3Exo8ZbqsHbSmegZVdseelIjFiA="
        }, {
          "num_cand": "U2FsdGVkX1+l+Um/LSIpkDmbQq3/r2GEeB30ixXdzt4=",
          "cpf": "U2FsdGVkX1/1SLir6glXUJ853suqTZNk9dBi4pvCVZI="
        }, {
          "num_cand": "U2FsdGVkX18uDm35vD+dGVHORFGQsApMu5W/ibinIzQ=",
          "cpf": "U2FsdGVkX1+BMLqf2MwAdCuA/uBnMgQKGg8+1pIKl64="
        }, {
          "num_cand": "U2FsdGVkX19eXuy5eowPT+xfWheZAi0Ao+axsMvqX5U=",
          "cpf": "U2FsdGVkX1/mp9G+PAWxYhkqbF2MWmVQhO2ju/hkQ5w="
        }, {
          "num_cand": "U2FsdGVkX19+W7uRFXiOUjHr6dAu5siCXMBSLyiUo+E=",
          "cpf": "U2FsdGVkX18ZzsRMB186yz0QR0rv/rn3tNVkBwhzKHw="
        }, {
          "num_cand": "U2FsdGVkX18BhRLg+GatfmkbWLEceakm1tI9THT46ws=",
          "cpf": "U2FsdGVkX1/hFHphgyeVA4PCYugJyox79LtDyWHXsiE="
        }, {
          "num_cand": "U2FsdGVkX1/DkEAXKFj6A+d8uqo5SDL2PBBYA6pqA1k=",
          "cpf": "U2FsdGVkX1+KRGW9tTrxsG9xMOXPLiP9vTEAAS8v5Wo="
        }, {
          "num_cand": "U2FsdGVkX1/20iFp/HF4QFpn4OR6vUP6pWN2s9d69XM=",
          "cpf": "U2FsdGVkX18H+EiFdi0PmILrjPxjiD1aFfZKB13N0oA="
        }, {
          "num_cand": "U2FsdGVkX197+KkZDJN0R7jXoUUj2bNHCoksKFYhCP4=",
          "cpf": "U2FsdGVkX1+wotExOWyBXdHUg+gZHQdfoCEXoIpUU34="
        }, {
          "num_cand": "U2FsdGVkX1+ius2HTJzNhNZxV3wPyn4kIV9uIZK0gdU=",
          "cpf": "U2FsdGVkX18+yK0LLNpl6wH9maU9HxH+aWemHKCC+ic="
        }, {
          "num_cand": "U2FsdGVkX18Zyi6erM2l06LReQBB37I0NgLkjGNNsy8=",
          "cpf": "U2FsdGVkX1/KsIKRlha7LeGh1ugMI1znrPdZJPwtJNQ="
        }, {
          "num_cand": "U2FsdGVkX1/c3NsZ9KjNYuA8w56rpIgS0nRUml3ywKg=",
          "cpf": "U2FsdGVkX18z8BreGE6BoKkgHhR8B0xg9r3bFiR/5PM="
        }, {
          "num_cand": "U2FsdGVkX18EH/hiUpqW4q/WQiEdpt3A4IGjirH6YtE=",
          "cpf": "U2FsdGVkX1/r4hEuwExPDALw0R68oo48mlt12Kdgpv4="
        }, {
          "num_cand": "U2FsdGVkX1+98E2F5qHKh1qP0Qw2DgNOC2HcevFKezA=",
          "cpf": "U2FsdGVkX19gmy3N8olfHodKLCTBnee4+sxj7HaGXLI="
        }, {
          "num_cand": "U2FsdGVkX19tQ0gm06W9UjxGkZ5eL0GihaM0qrX/b2s=",
          "cpf": "U2FsdGVkX18kjCKqSRCRQTvTMWjwR8LXW1psmk2Xeco="
        }, {
          "num_cand": "U2FsdGVkX1+MSdRpFH7Uy7m+xw7jg3PS8pxU6kN+rM0=",
          "cpf": "U2FsdGVkX1/6vnnuM04rNk6uw7ssNh+xjVxTvmd6CQY="
        }, {
          "num_cand": "U2FsdGVkX19IuBPtxuNcddnsIXaWsRVlRL+apecymao=",
          "cpf": "U2FsdGVkX1+3Fzw4i2v91JmWbQWdFa29QE6s3H7cxxs="
        }, {
          "num_cand": "U2FsdGVkX19PrL8S/ETaWchaujAs3lSIeUIw/dGKywo=",
          "cpf": "U2FsdGVkX1/TQ7CuSMEj0XtLQO42C3q/SjktHMsa+8s="
        }, {
          "num_cand": "U2FsdGVkX1+q6TMzHr9FxinC3Ri2jazO88RcjZNk/nU=",
          "cpf": "U2FsdGVkX19I1UsOHp23FrCsNVWaQnluQiLJTACOLN4="
        }, {
          "num_cand": "U2FsdGVkX1+Iy+igrcdZVIxpZ0oa0Mt7jFq8k4NcIhM=",
          "cpf": "U2FsdGVkX1/QMACH4DpMd3/Jo8B0ihovgSBaeDbqDQE="
        }, {
          "num_cand": "U2FsdGVkX1/ZAWeYI8X5+T8R1z6bBHg1uJ9+WE2K1+I=",
          "cpf": "U2FsdGVkX19145eHSvpzofarWHnPp9r1lqCr7+YYb/k="
        }, {
          "num_cand": "U2FsdGVkX19kjhnzSdB/fYnpFlDQHzXWynkfpZyqvEM=",
          "cpf": "U2FsdGVkX1+T90u5xOkNW4MP/+mdCDRFXpKDDLd4V6o="
        }, {
          "num_cand": "U2FsdGVkX1/FgtFuUFNZ7L2JFrfTazZ0ASdeiwqK0R8=",
          "cpf": "U2FsdGVkX19bK18KD8ZleV3WJaYNIK3mhUoR1uFMRF8="
        }, {
          "num_cand": "U2FsdGVkX1/Cr+6AoXoi5NUL60WtL10Dnr+q3T1E+X4=",
          "cpf": "U2FsdGVkX1/y404wE6EVFYsvv7t0iXoAeREhYAestqM="
        }, {
          "num_cand": "U2FsdGVkX19SXwU118COAlBdT5TVwiCkGHmnkFcJZWo=",
          "cpf": "U2FsdGVkX1/7ODaQx3cK3BLqGy/nXX202vzZ8D76rUQ="
        }, {
          "num_cand": "U2FsdGVkX18mO5WgePDFAlntJGDAuOBcWkR2Bn3pays=",
          "cpf": "U2FsdGVkX18BFh1rp4LSUJ+4wJ5iYLqCfANsPgBma08="
        }, {
          "num_cand": "U2FsdGVkX1/heo3IIiuuESB9SoeEqUL40lL0BA9qCL4=",
          "cpf": "U2FsdGVkX1/cMPWMGulUBYkCZvB2W70azTACJKqq8q4="
        }, {
          "num_cand": "U2FsdGVkX196DmvQLANRjWpcEQvxlgDhqrz02CyRiro=",
          "cpf": "U2FsdGVkX19qK9a8+XHybhZx6Yny+uBEJ6qq55iyBZU="
        }, {
          "num_cand": "U2FsdGVkX190ppBn1AA2RTiweMD/8twCUJvnNHzN7NM=",
          "cpf": "U2FsdGVkX19jxnsMrp/UO738fUhViHAa0V5sxVGPIPw="
        }, {
          "num_cand": "U2FsdGVkX1/6OFW3IPBdC+cVjH8IBt2F2UzS08B/Hm8=",
          "cpf": "U2FsdGVkX1/ctrEq6Zsy1hYOmfIZrT6GsuBKlmG/EL8="
        }, {
          "num_cand": "U2FsdGVkX19GUU3U+pnv0B0y/XiT5o1UQ4aXzGA4MYk=",
          "cpf": "U2FsdGVkX1/uXSSwcRpZMPLk3zv1pEJWNDfVxQdhn4E="
        }, {
          "num_cand": "U2FsdGVkX1/K15ZiIQql8C8WeDqzsDdjMWij/kZ36FA=",
          "cpf": "U2FsdGVkX190wGdpe6nx+EqvJbh0WS7Y3hsf2IMOKOo="
        }, {
          "num_cand": "U2FsdGVkX19fEdg7pdI7ccw/5ujUpRE4PaUX+989N8s=",
          "cpf": "U2FsdGVkX18U1/SWZ/Ixt+/VsbVWjrV5wO1VxCpHUmQ="
        }, {
          "num_cand": "U2FsdGVkX19MIRomtz+mPg9FqzT3eImu3zcBENbY65o=",
          "cpf": "U2FsdGVkX18OaOFJKenYkkedS5VDu7eNk7nJmHwcDc8="
        }, {
          "num_cand": "U2FsdGVkX1+QXD4wkPcjmIhPKtHOBRS1krjNTyY6LA4=",
          "cpf": "U2FsdGVkX1+WZxKsRdcPYEOJglzaIZI1M6UEV4oYODk="
        }, {
          "num_cand": "U2FsdGVkX19uEEZxs5Qg4eK9xWAfilzsugC4nc5XDlc=",
          "cpf": "U2FsdGVkX1+N4qr3PWkgqrdv/tFA4kJQiep9pHMxXB0="
        }, {
          "num_cand": "U2FsdGVkX196vybg4VLLBrJ9+6kuAYZgLwtqpESii/8=",
          "cpf": "U2FsdGVkX1/C2tos6gkCGlD2Dwy7DYpZwhe3Wfm3qIg="
        }, {
          "num_cand": "U2FsdGVkX18MaL3Dh59OQIS3GWksJUReYEUplmBO1Yc=",
          "cpf": "U2FsdGVkX1/cj2mkifOXcUHOwqqYT50QAhTuC3R+wec="
        }, {
          "num_cand": "U2FsdGVkX1/emYWFhWFh+SawO0kWAR6HgJVxUD5Zrn0=",
          "cpf": "U2FsdGVkX1/9sEkCQmUE8zHpW2+D6hQfNLxX8Rvs3z4="
        }, {
          "num_cand": "U2FsdGVkX18oVz9o3nyHhKGYD5apVumLEfdy1inDC1M=",
          "cpf": "U2FsdGVkX18u64katSCiAT14Kht44Q1B/6xxa6UbyJE="
        }, {
          "num_cand": "U2FsdGVkX1+Mxmcd0toHlfcDscxRsgdmLTZCajuxq6c=",
          "cpf": "U2FsdGVkX1+EaDT71HROa520fCUIInM5g0NUoVe9R0I="
        }, {
          "num_cand": "U2FsdGVkX18Er4Jczeaydg2XZhub3PgcREpFeqETGUc=",
          "cpf": "U2FsdGVkX18M1TRXAlJwswlHo7uKmwGKgeh6Q2Ulc5M="
        }, {
          "num_cand": "U2FsdGVkX18VF5PL9xydLC2QuP/n2Gp6O1b5alr1Ino=",
          "cpf": "U2FsdGVkX1/83yrP+eIOGZsTkoJxKFm6ziiF4ephR4k="
        }, {
          "num_cand": "U2FsdGVkX19fYrkdBfJMnuToQn2B9bnoQYHRB87mRh8=",
          "cpf": "U2FsdGVkX19+A8XQGMJFcRYl8gokyzV9jhlq6SojQlI="
        }, {
          "num_cand": "U2FsdGVkX18TTykkA9rKd9LlptGXHR1zXKnnYGvcGLw=",
          "cpf": "U2FsdGVkX1/qpcUDcuHqymtNF8lyXW1Vpv1bGVb9yVg="
        }, {
          "num_cand": "U2FsdGVkX1+1a7E78ehiOEJbxZJijzycR6rU03YJ2L8=",
          "cpf": "U2FsdGVkX18/l80iQjg9KTzQw3f0LgEYhbm8/suj0gQ="
        }, {
          "num_cand": "U2FsdGVkX1+eBfu7t3RnvOMHnEmdJBgIhyiVsYiaC7c=",
          "cpf": "U2FsdGVkX1/hlcV8OFFO1rhH1b3D58w0jUdn0NcEJEg="
        }, {
          "num_cand": "U2FsdGVkX18ohRzB54+9MFFPDfr5p1YASDZjvdDRyCo=",
          "cpf": "U2FsdGVkX18RL/DoF84ApaERJs7v1i5Dwlkmyvg+5YU="
        }, {
          "num_cand": "U2FsdGVkX18PNlys4mXuUgTgPWDSQc/A4JZ0uoqLOi8=",
          "cpf": "U2FsdGVkX19f7F+j7aDJzYyTHZwGyGLBkpcJPpHpL8Q="
        }, {
          "num_cand": "U2FsdGVkX1/SuEaPsoEtt2qcJDbOxgCekVWkKgexcbQ=",
          "cpf": "U2FsdGVkX1+Ms7foKcJtppIoW8Z+U8VSXYYBtx5NThw="
        }, {
          "num_cand": "U2FsdGVkX1+TDVDHA1x6NZLg1mvooG2TdkU9k8/zM7U=",
          "cpf": "U2FsdGVkX19qSAntmIoweLg3Hgmd2Y+fd1tYH8hX3ro="
        }, {
          "num_cand": "U2FsdGVkX1+PsqHsCb9x8HezAhIC/ZcCH3vNbyffmb8=",
          "cpf": "U2FsdGVkX19Zb2e+GFoRmOG8PoMznk9bv7Px4s54JzY="
        }, {
          "num_cand": "U2FsdGVkX1++QdtKv0N4Tyt4EjeqcNsF35F613g3bt8=",
          "cpf": "U2FsdGVkX1/W0R20ar6Pb9I/rbrQKbofyk22LhsSVMQ="
        }, {
          "num_cand": "U2FsdGVkX19kMQGnMaAWZEHqLjwb2+AHcPn9a7HlpSk=",
          "cpf": "U2FsdGVkX1/YOGQi8IeU1+QrnLeyyu52rULO+Hk62No="
        }, {
          "num_cand": "U2FsdGVkX18PxvL1fVgQ4lZzuXcLicslDD+h+C5egc0=",
          "cpf": "U2FsdGVkX1/QCpHi/WVK3btAnT+G1QWmZcX7/wn5Hg4="
        }, {
          "num_cand": "U2FsdGVkX19rIE70V2vEZv4FlVLNvFzXmP4BD53u1y8=",
          "cpf": "U2FsdGVkX18eRGUKwMLdTAdDIaXYKK/ggPmnawqxu+w="
        }, {
          "num_cand": "U2FsdGVkX18prSWpvKwNhYgXuIOfCMi3qeAt0BHes4I=",
          "cpf": "U2FsdGVkX18zXlk0kuKsAWhw3PM3a4NInsM4HfRC3NM="
        }, {
          "num_cand": "U2FsdGVkX1+k5H4O8Zx75dSwdy4EVWQxzrHty6cCAHI=",
          "cpf": "U2FsdGVkX199hIo9qqfB1KDeuo/J8hKs4AhHDmjbO44="
        }, {
          "num_cand": "U2FsdGVkX1+jO0IUrrsNKcYUIgWrYMygVxY0Ec8o6Gs=",
          "cpf": "U2FsdGVkX18QvQw++8u29/saD4MWqjcnGAF7adfhHKY="
        }, {
          "num_cand": "U2FsdGVkX1/7dE49zXm2Q0ToaXBwdpssw/0Imj252lo=",
          "cpf": "U2FsdGVkX1/WqzwbtjGqMMEXbFbIbBRwvDPCymLFT7M="
        }, {
          "num_cand": "U2FsdGVkX1+WM9V24tuEcbMMIzHY6TQHr9IfVn88kpY=",
          "cpf": "U2FsdGVkX1/hzYsZ3+i0stkOUMxISdBbdE4k4cm/STk="
        }, {
          "num_cand": "U2FsdGVkX191h/iE34l6u4bZNWI1j0fbh8G9BoqRcPo=",
          "cpf": "U2FsdGVkX1/9rtS7wE4YT/k4xcoNsPsMPq5bszGmYCc="
        }, {
          "num_cand": "U2FsdGVkX1/xFgM4OMPFOci05yijzNiFGCnZGBbklPM=",
          "cpf": "U2FsdGVkX1+IXaJsL+Z/UosFJj+wjYnUxhPOcj4+Tpw="
        }, {
          "num_cand": "U2FsdGVkX18WeFABttjfmMbcGdA8SHnq8UWhrGyGXT0=",
          "cpf": "U2FsdGVkX1++jrA65KJTw6+kVyzp5VXxlQ0U0be/Ny0="
        }, {
          "num_cand": "U2FsdGVkX1/ZRyG6UTD+HcKDljp+a5BjBPqBp2j1QOs=",
          "cpf": "U2FsdGVkX1+c4xroy2SKaHddOuLMwPLEqJ6Qg8Ai/qc="
        }, {
          "num_cand": "U2FsdGVkX1/JhJZcGvrwRsWYKRbONwojFjIYedh7RJY=",
          "cpf": "U2FsdGVkX19dUZ0f2Wm24yC+me1AKg168zpAFn64rE8="
        }, {
          "num_cand": "U2FsdGVkX1/3sYJJeXMBaN8LWMj8//7a3WZzP25KF3o=",
          "cpf": "U2FsdGVkX1/3eM/LzazFCsJnF3T6fBeP6TUSoBE5u8g="
        }, {
          "num_cand": "U2FsdGVkX19kLIGJ6ZzbOWMVyYD5RqV/5WKKa0AnD/M=",
          "cpf": "U2FsdGVkX1/Uv6E55sSCp/DrILVGnHOfrYIVULbgDdA="
        }, {
          "num_cand": "U2FsdGVkX19TPYKLpKE2yUzC/Im/klQVScHe38YtV4c=",
          "cpf": "U2FsdGVkX1/J7nsAvUBH1F/0sthrex80X5nVuSr4Z68="
        }, {
          "num_cand": "U2FsdGVkX1+9VW+q+PK7nvhyLXxV04z1owzJlpwHYEo=",
          "cpf": "U2FsdGVkX1+aLNPHs8/DfOTbVnbtAaWLlgT4OMwMZyE="
        }, {
          "num_cand": "U2FsdGVkX190qeRq/giYgCZFqccpG72BOrqW+0pGebw=",
          "cpf": "U2FsdGVkX18wSqCPFItIzrITdSECFviszs2J7sBkZgs="
        }, {
          "num_cand": "U2FsdGVkX18+24Kmlenkfc5FQVDrDi43E2XRn40VsDg=",
          "cpf": "U2FsdGVkX190f78+FKQyK3F9TuKypp7CbysdMZitq88="
        }, {
          "num_cand": "U2FsdGVkX19VmWdTa5xEJacUOx3cbJBtdfAmYsW0mLw=",
          "cpf": "U2FsdGVkX1+2hXrjVmAodgm5aVK0na+sY23xX/oKsAw="
        }, {
          "num_cand": "U2FsdGVkX18QDgcNxvRozx4A+tcv2klzoXaAOld3zM8=",
          "cpf": "U2FsdGVkX19taSxDG8YVa7wxefxLLoxeFJ6kXyw4d0w="
        }, {
          "num_cand": "U2FsdGVkX1/mi/SS9ZvVtC8SDZWlfbrmi5QP6G7W5TE=",
          "cpf": "U2FsdGVkX1/6us0/ijbpEygt3jHBo9wSySQEEyZRrMA="
        }, {
          "num_cand": "U2FsdGVkX1/EKmQb9IwVjWtDH5QC3hUJTNpkok3WvPM=",
          "cpf": "U2FsdGVkX1+iv2ctH3nNBjraKRaC5r1JqQWy8afNTeU="
        }, {
          "num_cand": "U2FsdGVkX1+BPGhFdDvPGcP0h9BKoPgpipjBW+sab4g=",
          "cpf": "U2FsdGVkX1/aizwaP+3oSU2VFtCcMkZv6P4PiS1YRiA="
        }, {
          "num_cand": "U2FsdGVkX1+o3ZOIb9lhMiBw2F5IZQvE2IdnK8xiZPw=",
          "cpf": "U2FsdGVkX1+hkTxUIcNBpP+XiG26z60fxLT3sfjbCCw="
        }, {
          "num_cand": "U2FsdGVkX1+LErzOflRUzJjE/qdkdsLfvGJecrfFML0=",
          "cpf": "U2FsdGVkX19Hp3CQINK7NOIxe7W3o4gybaLG9KM07Zk="
        }, {
          "num_cand": "U2FsdGVkX197uMRAExIrQhVpSnS8JtEaTrMGIGnFplI=",
          "cpf": "U2FsdGVkX19VpIjqi0nKD9bk6g1fx3chHo2+vyyqqHA="
        }, {
          "num_cand": "U2FsdGVkX188KKwGahTxI4C69cmIox/m/cbxTXOnXWQ=",
          "cpf": "U2FsdGVkX18WOXi44nifY+I+Aj2JlDaPgfU65T4/Yeg="
        }, {
          "num_cand": "U2FsdGVkX19y3vx2Ut0ziUPwUnOj+3mmDTT5CJnZk9Q=",
          "cpf": "U2FsdGVkX18xCfK5nc0FBQiKuV84J5QU8bJtCeAbHvY="
        }, {
          "num_cand": "U2FsdGVkX18fvRRCwc2hVS2TIKAlFQtIB+wjJb20nok=",
          "cpf": "U2FsdGVkX19fcMYPl2I7fhQ2L0h8Pwmn1shmdO6ahUk="
        }, {
          "num_cand": "U2FsdGVkX18o4q6SDgD3nqZC809L/cudN/eN0s+34+g=",
          "cpf": "U2FsdGVkX1+iReJog0/lFPclhDM5O4b6KPXWwA0yWc4="
        }, {
          "num_cand": "U2FsdGVkX19yq38axmORGyQ+O/TE7FWzeHpUr/xtdP4=",
          "cpf": "U2FsdGVkX1+uFyG+FuosHxqCN+J2Md2EjzUCuQ/jUdo="
        }, {
          "num_cand": "U2FsdGVkX1/CTBwdu4gwsZF6rRo0EuNzmr5MDvZnHBg=",
          "cpf": "U2FsdGVkX1+w75BjMXZMj6dNhhNSvk3qE89J03r+Vg4="
        }, {
          "num_cand": "U2FsdGVkX19yY7NoB7HjNqIMgnE1etPtn5FlrCGYrDY=",
          "cpf": "U2FsdGVkX1/KoFouXOsiihLm6gppfzyWQqqk+SeRI3o="
        }, {
          "num_cand": "U2FsdGVkX18TSMPEvDh2N5kBLoAialq6hAdLTH++KIw=",
          "cpf": "U2FsdGVkX1+ElHeB47O2nCgCWkF84BQ/zLS09nxaTlg="
        }, {
          "num_cand": "U2FsdGVkX19Fp9jGlMNr/IOCaU19SILzGCjIYeApogc=",
          "cpf": "U2FsdGVkX1+TW05MmvL6kORDWPTwIg12I8EvgfUSbg8="
        }, {
          "num_cand": "U2FsdGVkX188rJUEIuDPSXU3owZD97NzLElU2Ok1e6s=",
          "cpf": "U2FsdGVkX18+9HGxHFaO2Jr9heiJbQG4eDmct0e0p20="
        }, {
          "num_cand": "U2FsdGVkX1+iSuaeWEmieocpwV6CQC46ueTqhNYpngw=",
          "cpf": "U2FsdGVkX1/DNm0JPsRffMe7UJGZh0aZFq86+HvA04Y="
        }, {
          "num_cand": "U2FsdGVkX1+h9PN9m5aHh0rT54PNXK/vu08o2NcaKsw=",
          "cpf": "U2FsdGVkX1+al1JwoC9uvJXIgqdbNoNpSFYNNB8Qd5w="
        }, {
          "num_cand": "U2FsdGVkX19bFXaRC13CxPPRpdLZzI7G/tR+6diwAvY=",
          "cpf": "U2FsdGVkX19jMiaOAbKQLtcSbY7+a7nSkN4ItG7vgA8="
        }, {
          "num_cand": "U2FsdGVkX19mi57DBTCeo40BPlzGjWKfoPjYhKpmzpw=",
          "cpf": "U2FsdGVkX18QbpgJIugq52i51ORQjvPAXcrHrphNInk="
        }, {
          "num_cand": "U2FsdGVkX1+B8cCUBW4ewk5tKJ+4XKnFGKvUEyMllOk=",
          "cpf": "U2FsdGVkX1/6gqos7FmkM6pvSIXpaD8GFSRD5Tt+yS8="
        }, {
          "num_cand": "U2FsdGVkX19OPQwiQttduEV7/AP6iIzsPhudGMrOz/M=",
          "cpf": "U2FsdGVkX1+7z6suqcXzmVLzUGrY3GwapsdBwQxBCas="
        }, {
          "num_cand": "U2FsdGVkX1/wbsbq+wXAsjeES/Z316O6auk+nGbqMPY=",
          "cpf": "U2FsdGVkX1/kIu+D4Zo0oI0adAU7xTegjNuLoML0b0E="
        }, {
          "num_cand": "U2FsdGVkX1+rnqHvGVxorizNRGnlFUA3xe43Chn/iIw=",
          "cpf": "U2FsdGVkX1/DW9iv45fmUWketglnuhOcFFXkd0s/Ve4="
        }, {
          "num_cand": "U2FsdGVkX19lRRaQUxfcxHc8eMurvAYIb4LFtbGn3p8=",
          "cpf": "U2FsdGVkX1+SQHRrcKcKQrDjEiCqTRFtNHFeUe3LdmQ="
        }, {
          "num_cand": "U2FsdGVkX1+9DOqbQ9BvpE5DzU7hd8du0s/AMktDCr8=",
          "cpf": "U2FsdGVkX1/WIsgRX/sn1muGLujhrm92fNc2e3Ja/oQ="
        }, {
          "num_cand": "U2FsdGVkX1/mfXJQBWZw9CE5f6itvxz4pSi5LJK3Ozg=",
          "cpf": "U2FsdGVkX1/6rmW+OvX5IM74nSR98EJgcH44OByz1Jk="
        }, {
          "num_cand": "U2FsdGVkX186PaP4ux9bkNo/H2Z7/6/jazdHg2jy//k=",
          "cpf": "U2FsdGVkX19rr03KXilu3fFLF8CX6yXujsdBsQ0/dgE="
        }, {
          "num_cand": "U2FsdGVkX1/la0RAVJ9CfMEA4bIpvYa6JPnUxEY8Wyc=",
          "cpf": "U2FsdGVkX19lyymK67Uad5qgRLRWgWyotpj6ssP3tSY="
        }, {
          "num_cand": "U2FsdGVkX19Wo+yS3EHc8PSdQWoaPwoZLo1AXn8fifY=",
          "cpf": "U2FsdGVkX1/esoQ+wjAhHodNROYPkgGhZefOBlgA7aU="
        }, {
          "num_cand": "U2FsdGVkX1/vi+tsDoNr+ooLzy+2bQ0Qgekt2SDc8Uc=",
          "cpf": "U2FsdGVkX19jBLLlDMmaPorkChVR7S4kwXmRbmQnays="
        }, {
          "num_cand": "U2FsdGVkX1+oPxxXxJA+URdxQPKWh2tEZN0XKVO171w=",
          "cpf": "U2FsdGVkX19qTS9qO7C4ODGknqcghATe29MpF697E44="
        }, {
          "num_cand": "U2FsdGVkX18dkJcP24ihfX2dKTOW0ZVst7QQZWtEFo4=",
          "cpf": "U2FsdGVkX1/ZDSTErddMbbenwWJqJfbmzdASrRJqcd0="
        }, {
          "num_cand": "U2FsdGVkX1/sl3YnZAGu5a8m7HwZtkijTc1kEoSkcqw=",
          "cpf": "U2FsdGVkX19d5jeWV1wZlcldMKEAObz46skhmee7FpM="
        }, {
          "num_cand": "U2FsdGVkX1/0cuFv5PbkV3Fbb+lJTC8QIoOuk0hrvEI=",
          "cpf": "U2FsdGVkX19X0j8DG17OhxX7woFzC9lKG5q9Vzg6xPE="
        }, {
          "num_cand": "U2FsdGVkX18wy5U7msQ9kUMZaO3iBkPeREwzf2B+qMI=",
          "cpf": "U2FsdGVkX18Kc3JmZVmHsBOzy6lskJe+owsM0STAeaQ="
        }, {
          "num_cand": "U2FsdGVkX18cwi7QM5Hj0MsHIGj2ETkNK5hT83yrwa4=",
          "cpf": "U2FsdGVkX1+E76H2VXPEIQVKqi0I4f5cNzeleC7kiLs="
        }, {
          "num_cand": "U2FsdGVkX18iR6S9I5v+7NaPFmQ6bU9SswT7BTBZ/mM=",
          "cpf": "U2FsdGVkX18dpMM3yWpxAZbznOpCEa0vGNp53jwmVW8="
        }, {
          "num_cand": "U2FsdGVkX183OAInt97dZFjGwDtm50owY3tL4VFOwF0=",
          "cpf": "U2FsdGVkX18RhrAdEQHDQSHhPFsrs7Qx2ygcisyxYD0="
        }, {
          "num_cand": "U2FsdGVkX19KPGbVyLT4BEtCpxVOjUOjzdvRAy5ruEI=",
          "cpf": "U2FsdGVkX19M2MUJZPA7H+YYxGexaGDh6gXl63BQp+o="
        }, {
          "num_cand": "U2FsdGVkX18raamjEtCYg2WMOD+O7EAhl5k77XozBM8=",
          "cpf": "U2FsdGVkX19frAyqfPXa4YpDUxmyPeFK4QC2cAeKHJw="
        }, {
          "num_cand": "U2FsdGVkX19UnJRL+8GEw+8HyG5jXZYmA0Hsj142DKM=",
          "cpf": "U2FsdGVkX1+i5j0hwADKVoQ4QWO5JFmXWHMPG9XJvE8="
        }, {
          "num_cand": "U2FsdGVkX1+SZ2g59zyEEB03GUovoSVlznJpV6plte4=",
          "cpf": "U2FsdGVkX18woQ3JjvnOJFG4Lxv5eIo0CZ4OVKcEwUU="
        }, {
          "num_cand": "U2FsdGVkX19t/cxRj5pkmm7A3dfFQsHb8kls7G8sgl0=",
          "cpf": "U2FsdGVkX19Tz9F6qU5Cx4/M+J251hJ+2SR0ebZnQcg="
        }, {
          "num_cand": "U2FsdGVkX19hjuVjRcmj/QxXA/T2DfhshNEHAW6t7os=",
          "cpf": "U2FsdGVkX1/LlCNOACmXbg/W90ps+myUmptlkW9Yrk0="
        }, {
          "num_cand": "U2FsdGVkX18VRBhcpYW0cA95ctUb70DX182cjCyGaKE=",
          "cpf": "U2FsdGVkX193QXeeDj4iHMYowgmB9AilGYXr2Fo4L8o="
        }, {
          "num_cand": "U2FsdGVkX1/SxX14eFlSN0MTuu0ZOfnYt9RRb2WnOrY=",
          "cpf": "U2FsdGVkX19zVx8fsetUWXJB+MvOEvMx6KvYPlEbNXk="
        }, {
          "num_cand": "U2FsdGVkX1/us3XRy9xo/9HY+TX69PT7tHQU2eKznss=",
          "cpf": "U2FsdGVkX18tW+C2RIakXA7DPUwHIe3k7ZpGt3vrOL0="
        }, {
          "num_cand": "U2FsdGVkX1/uVRJgcP3yTH4ttSrfBwcYO7gH+HrQvLE=",
          "cpf": "U2FsdGVkX19jgvciGi2EQ2Mciny0BuJbxYOxsAzNZmU="
        }, {
          "num_cand": "U2FsdGVkX1/Bv6Hy7TjToN+pLTh2kHDYr9SJu8nHb88=",
          "cpf": "U2FsdGVkX1/jT2D+xczT4VrMbaS8gM06mkPHmrEnRyA="
        }, {
          "num_cand": "U2FsdGVkX1+hsb5B3rxNJPWAZvo5qQFraZUd0PeQ9PQ=",
          "cpf": "U2FsdGVkX1+tYCl4Wc0ucrWz1ZYFlmBxL6NOm/Zi3Dw="
        }, {
          "num_cand": "U2FsdGVkX1/fsnmUv5r8y8MgM1t817GT3he87o1Y0rE=",
          "cpf": "U2FsdGVkX19AEXZ/+P0d/z0fotyBdUmE+8rSiwqkuXg="
        }, {
          "num_cand": "U2FsdGVkX1/PSLlMyzP5D9zDbrwj61hnbP1AJl/EOF0=",
          "cpf": "U2FsdGVkX1+EOoIAFRa3DthFLmDjGOQ8KIhGGlqtQiU="
        }, {
          "num_cand": "U2FsdGVkX19hIchkqy/QhEXNNjBjrFuv4TUdT6qpASY=",
          "cpf": "U2FsdGVkX19oQ4B3+/1L7Q01JEsHOsr1iaCXjlQePDM="
        }, {
          "num_cand": "U2FsdGVkX19Pk9jnwtjCz0MVbB9QqvIrhVN3QKOdYck=",
          "cpf": "U2FsdGVkX1/YArv2zrQC7k+aSSY7ddON5oi95fwK77M="
        }, {
          "num_cand": "U2FsdGVkX1/idCUkskR0H8+ealgaOvnDnMfGH8PIoBo=",
          "cpf": "U2FsdGVkX1/oynJvsV8Sk/+neNjMcQmYRqpydSVR5+s="
        }, {
          "num_cand": "U2FsdGVkX18Oxxhpa0dzJYMbRStSKNL6o515vzb63zI=",
          "cpf": "U2FsdGVkX1/Rlwsl3jZRe/NPFvRmMlGN0NLjMwsvY8U="
        }, {
          "num_cand": "U2FsdGVkX1+1jC4Gb7p52CdknLNEaNwFS7ab5w/K3Is=",
          "cpf": "U2FsdGVkX19Hjm5eufKobrG0fpdRk0/BKhh7xcP5U3Q="
        }, {
          "num_cand": "U2FsdGVkX19Zadskty0TF3ixCv8uthPaxXRqFmXO9I4=",
          "cpf": "U2FsdGVkX1/K9em5kqYO+NMGtvL9KqHDr8AIoyQKMA8="
        }, {
          "num_cand": "U2FsdGVkX18iUDjICaweIvQhFgW/vkMmg6qH30tMzAo=",
          "cpf": "U2FsdGVkX1+BduxXUp0VtNFW59njs+o4VWoYWhHyEz8="
        }, {
          "num_cand": "U2FsdGVkX19+2+19x5EbDmgrLChsjZOJVJNz7jTxJRs=",
          "cpf": "U2FsdGVkX18FI6BICiugO1wG/fzLJ0wolY0pS06A09o="
        }, {
          "num_cand": "U2FsdGVkX1970CatONfJchKI63bB9SzQ1OGzPzjK76c=",
          "cpf": "U2FsdGVkX18gByVNzTsJSGb3z0qzjneTe8SqTzPpPok="
        }, {
          "num_cand": "U2FsdGVkX19c2C70ziSXT8OrCIN5GoOV3jr74KUm96U=",
          "cpf": "U2FsdGVkX185Q0K5HpAk5qPiuHJMr10ZK6/iixLj7Vs="
        }, {
          "num_cand": "U2FsdGVkX182TrARpreQKIuIYtlnaZAE8YcklnPISPs=",
          "cpf": "U2FsdGVkX1/avheqyv4KMLVHTk0mBHtHWc+49DsoTy4="
        }, {
          "num_cand": "U2FsdGVkX1+ksCgolP4W6R14KUUlSB+JiswjdeDzVSY=",
          "cpf": "U2FsdGVkX1/zbaWErRTZV2ZIpKh4B9M4L4GpZfJC5nQ="
        }, {
          "num_cand": "U2FsdGVkX1/6Izdv7rTa6uDPX0qecUlygkMT82uBB54=",
          "cpf": "U2FsdGVkX19tW5JFLsDp0JIV7essojsVM381027OE+Y="
        }, {
          "num_cand": "U2FsdGVkX19UuNSmav1Dummw+kBmqxFdsfkTi7nqsmo=",
          "cpf": "U2FsdGVkX1/xBOv6lFvVj8rk2s/lsYM7PzwUJ/wXIOs="
        }, {
          "num_cand": "U2FsdGVkX1/UxtMpJ27Lic0a30+gPX1+q+YpJ2nJY8k=",
          "cpf": "U2FsdGVkX18092iQK4IyzCfVF1v043coFTGCL8R0W8M="
        }, {
          "num_cand": "U2FsdGVkX19fVekkOdnvYAMHN51ADdreRsKPiOtWHJU=",
          "cpf": "U2FsdGVkX19mZBYJVQlPVr2yqOHfqSZFeWmTwxY66hU="
        }, {
          "num_cand": "U2FsdGVkX18LDMsqk2iQaiiZX+Rx/DVkotmfdl43l40=",
          "cpf": "U2FsdGVkX1/uOKTWI1KIcWAam+neV8S63nBPRSeKFAY="
        }, {
          "num_cand": "U2FsdGVkX1/3PZuzwPSkJewNMm0XN/etZ8dXJ2Xsa28=",
          "cpf": "U2FsdGVkX1/WnuKGmet7buSNDYIuAi0ZphlS2OkXTa4="
        }, {
          "num_cand": "U2FsdGVkX187+9VjzWNhAj8aQtm/WfdzHwyGzoIEKMs=",
          "cpf": "U2FsdGVkX18aCZiygKob5wdq5eP5B4ItYcZ2YcUQsO0="
        }, {
          "num_cand": "U2FsdGVkX19fDt1duzCxT/ojSRWaAy6Al3iY0Eo+KOM=",
          "cpf": "U2FsdGVkX1+uW7I/qvkr+jdHd7cGFreCDFX2ywcvQaA="
        }, {
          "num_cand": "U2FsdGVkX1/gGHaNgAH7MqOclEKYUok8L+HaNs28UVg=",
          "cpf": "U2FsdGVkX1+SuX5AyKP034u5fKd/fDkdVD9OkL6Ay7g="
        }, {
          "num_cand": "U2FsdGVkX1/WUfLzAA9K9/cjiiV+Geg7RApEHEZoFrE=",
          "cpf": "U2FsdGVkX19IcBfVvhHaV+DVBXUyeoOH83g6npw29rQ="
        }, {
          "num_cand": "U2FsdGVkX19wqQA4YyyBLE0fDtiXUIUzRZQeXtZ5WZU=",
          "cpf": "U2FsdGVkX1+finjKrLyGOSlv9NWeICzSzc2HzL4a3nw="
        }, {
          "num_cand": "U2FsdGVkX1+qP8FOtKlQuOfEbOBhMZEQTKkFtAzMqUQ=",
          "cpf": "U2FsdGVkX1/NR/B7KJt4BysV5PwL5xU52obOep6Botg="
        }, {
          "num_cand": "U2FsdGVkX18ed4tbiUvQvCdDZRXBUENJEm39x4xhe5M=",
          "cpf": "U2FsdGVkX1+5PRKsNqmJ6dZs3xwc4m+8FAkr23qmsJY="
        }, {
          "num_cand": "U2FsdGVkX19+UCXpCW9jTXiH+BS7/ZyyXa196umKL7A=",
          "cpf": "U2FsdGVkX18dUSjnN2jzbjjNSj6HsawE06++r+jFNyA="
        }, {
          "num_cand": "U2FsdGVkX18L4pBwS1yVH1T7R4lV9OPdPUPoaJay/Lg=",
          "cpf": "U2FsdGVkX1+72l1UtBNyhrbj1aleoa+0YQAEBbDz7GU="
        }, {
          "num_cand": "U2FsdGVkX1/0lR2GlIClvW6WFgR+M6N6crRD9Ky0U8A=",
          "cpf": "U2FsdGVkX19KKcAyP6PZdPOaTsfXHj7r0DL1YaOEGak="
        }, {
          "num_cand": "U2FsdGVkX1+0C2S1PjIpo26Q2SBgQp/depZTbk/px2c=",
          "cpf": "U2FsdGVkX18fwXledAgodcjtHxfWoPL38IiIAcL+DBo="
        }, {
          "num_cand": "U2FsdGVkX1+Mos7OeBzY0X8YRKr66MwCfAP7WHFeWk0=",
          "cpf": "U2FsdGVkX1+gi56OfA6dwZlNEEDGSTnsOPZCj9jfQag="
        }, {
          "num_cand": "U2FsdGVkX195hcB02bAfAcmdxaa0tf/1PZheIAr0j6E=",
          "cpf": "U2FsdGVkX1+lhayi0sEGG6rem8Ehaer0r1fenTFsdjY="
        }, {
          "num_cand": "U2FsdGVkX1/Tw794XZA1n/Bd+MCsOnTa7UB4FErdoug=",
          "cpf": "U2FsdGVkX185eyOzPXF1H8f//pgEl47FQcS0w6cElH4="
        }, {
          "num_cand": "U2FsdGVkX1+IvA6F0z4oX72ayWt7z5vjkzSNInZ42XM=",
          "cpf": "U2FsdGVkX18eUmN306riP9rub8HpNHFFYTmiZf5ApWU="
        }, {
          "num_cand": "U2FsdGVkX1+ruuoHihU7Gg5yvD+jREWUIpowZw8bSq4=",
          "cpf": "U2FsdGVkX18LXsMDME1E8xItpBzslBy1fQMAXC6fY/s="
        }, {
          "num_cand": "U2FsdGVkX19M6HLtO1XoK3mHg66TAlUfgrdQ+rrogh0=",
          "cpf": "U2FsdGVkX1/RUdItU14vHrswzOcho/Tkkb89z/wP6ro="
        }, {
          "num_cand": "U2FsdGVkX19ree1RXMe3lpNOqae2iEb/vlkYae6TxWg=",
          "cpf": "U2FsdGVkX18mSGla9pIJ9FZ0lywmiMBsA0OoY9eeANc="
        }, {
          "num_cand": "U2FsdGVkX1+dg9qz6UbktJQxnnXaLrlcPaozw9f0od8=",
          "cpf": "U2FsdGVkX1/y2tGlQ8lNc5HMSan4S/YcRD0AcWHrFH8="
        }, {
          "num_cand": "U2FsdGVkX1/cTDwbuZ16vo7qUT7uS+lbGbfatRDSpG0=",
          "cpf": "U2FsdGVkX199zbDYPqeL0/dwTk33GsXLucvHhCYXIqE="
        }, {
          "num_cand": "U2FsdGVkX18MbMlSWhvWapoUJMKycIZYihOmsx3adpk=",
          "cpf": "U2FsdGVkX19tfMCUGrvNLanaVwzYGPC1Xw4o8j8zlp4="
        }, {
          "num_cand": "U2FsdGVkX18XOroeY6+HbjGEvURe8R7p/NCEsn9yCIk=",
          "cpf": "U2FsdGVkX1/6RD0cwjtN9iPCV7JVmdk4qYS/NUlFNbQ="
        }, {
          "num_cand": "U2FsdGVkX19CscJAZivtpMmyzkbi+kttMCXX2ouj2nc=",
          "cpf": "U2FsdGVkX1+ImSmRV4DuSHNS13ZjpCfc3QFQOIPeOoY="
        }, {
          "num_cand": "U2FsdGVkX18FlpzoEs58gp5FB2MVUqiEEVJGpRi0AoI=",
          "cpf": "U2FsdGVkX1/whPrl3983Rnn93mHuUPpXT2yML3wdgEc="
        }, {
          "num_cand": "U2FsdGVkX1+HWGvylQgSAAoyVDhzKuNYgFl47ebPAGQ=",
          "cpf": "U2FsdGVkX19ob98ACOHyJL8A2twwVTUjYW//4gskzCY="
        }, {
          "num_cand": "U2FsdGVkX18jvCZzT2m36ihQUkC85K8DzdDyy2PXYZ0=",
          "cpf": "U2FsdGVkX1+c++UD0rhr7TtsGdQ7SA7UUwi69DRTfo8="
        }, {
          "num_cand": "U2FsdGVkX19KUgGd3JxxYNvd24StDvV8TqjnVwIfGOU=",
          "cpf": "U2FsdGVkX19Od6oktIZbQ1rNlllWvHvLLadh3mMS038="
        }, {
          "num_cand": "U2FsdGVkX1+FoIxefy0auwTCXBqj1gGJ2ppa/VjmHK4=",
          "cpf": "U2FsdGVkX19viohW218dPXAwvexPPB2eyEEaWoJpVDY="
        }, {
          "num_cand": "U2FsdGVkX1+qZAwO1X9xEWaLxCi4UpKm+AZxHLB1R8M=",
          "cpf": "U2FsdGVkX18uaCq1IUeZ8iasZuH+rWOSbdsvMEYf2ts="
        }, {
          "num_cand": "U2FsdGVkX19275wrt8ZfExfKWVtZLxsO6XGTBpGUq9A=",
          "cpf": "U2FsdGVkX1/03K8nrj7yqXaD9uEFKMZ6d3MWJtq6+3s="
        }, {
          "num_cand": "U2FsdGVkX18H4GHE/8I76hN7WusMyT9pnBls94+fWaI=",
          "cpf": "U2FsdGVkX1+F6hNi96XPqoT7PSck74nAIKERPHydN3I="
        }, {
          "num_cand": "U2FsdGVkX18L3/mfqdKUrf5ephB4DJnPRJp3Re9WaGM=",
          "cpf": "U2FsdGVkX18AJtg8P8WlYFqVOb0w4nmAtSCD12ilHHY="
        }, {
          "num_cand": "U2FsdGVkX19arB7HteXUjOyqrBeL03MnMPNR47Moy10=",
          "cpf": "U2FsdGVkX18MRVTFFTIBP+4be65V58M0cfk8+W5nwfM="
        }, {
          "num_cand": "U2FsdGVkX18nMPYv8usJ2++KIHg+G0eKObx6KK+POSc=",
          "cpf": "U2FsdGVkX1/N2RR4dRcudWIec8f9dxprndaPHCdovQQ="
        }, {
          "num_cand": "U2FsdGVkX1+Z9pVkjks+1w/gnvrnP7v8Eh85o6k64F0=",
          "cpf": "U2FsdGVkX18Eb/D55Fv0lNlFqZuN+OB0c/AozegchN4="
        }, {
          "num_cand": "U2FsdGVkX186hLvnw2w4ElTDT9Aqxt4ZBfn0x8QFH3o=",
          "cpf": "U2FsdGVkX1+aDEilDNffXewUxWWWqUhXhCZBRqeRKZE="
        }, {
          "num_cand": "U2FsdGVkX1/o48SxlhOuFBHHLFXHtak2jho2vwwoNyM=",
          "cpf": "U2FsdGVkX190PJUpE0NGxj0xIxAnTQ9+mpPZ5gd/j80="
        }, {
          "num_cand": "U2FsdGVkX1+Ruvw2V/JdnbosxcptfO4h9/+oaKC65L4=",
          "cpf": "U2FsdGVkX1+Y96uNA7SM2HrmB+vLquhI4z3Tr3Whoig="
        }, {
          "num_cand": "U2FsdGVkX1/94H6m9bNo0olEeI9raVVjJfOSIBsmAZU=",
          "cpf": "U2FsdGVkX1+VZcnGaKKsJYt4JhzuVR+lJNNvAjiMetA="
        }, {
          "num_cand": "U2FsdGVkX19SDPKtGefHy4XJL6eZe4IQGhANKBiyy8c=",
          "cpf": "U2FsdGVkX18DAjVVj08BDpIDQOwmxjjiaAbenrel6uA="
        }, {
          "num_cand": "U2FsdGVkX1/HpCXn23gi2jOrtK48nYLrjlEOglQ/BLo=",
          "cpf": "U2FsdGVkX1+toxxSgxZMNV6R9DjH6ai2hq7+4TQqL6A="
        }, {
          "num_cand": "U2FsdGVkX18tp4TlmVH+KRPt6tf/RykUZ9v16J9cW34=",
          "cpf": "U2FsdGVkX1/acxyvsge9rZNnfkA+kUTpx4fZMbn3Rbw="
        }, {
          "num_cand": "U2FsdGVkX1969PHEhlon1xBSlwX2OUME4Ahr4D0adzk=",
          "cpf": "U2FsdGVkX1+FeWNljKhYGn+hNWAmF5f5t8zvm+v5JTg="
        }, {
          "num_cand": "U2FsdGVkX18U/Nw6ENupcTIZdSzxXa2YplNZQ7sHgxQ=",
          "cpf": "U2FsdGVkX1/W0mHmVZHKfIghiOmoV2ZW4yLd5RkNTM4="
        }, {
          "num_cand": "U2FsdGVkX19mIjkEpMJqysRKBN5pW2w999VvZcLHO6Y=",
          "cpf": "U2FsdGVkX1+P7icGbEzQL6LFRENRqyzweXgZnqTRORY="
        }, {
          "num_cand": "U2FsdGVkX1/KXPxM8XJG88iyjHSctwNktK88LDCqjVw=",
          "cpf": "U2FsdGVkX1/waUrI+ZzXsUkCuOPVU7JCtIhyd9zMY/g="
        }, {
          "num_cand": "U2FsdGVkX1+OXSlgh0jIN8582sSShLl8vK3vg0T/VbA=",
          "cpf": "U2FsdGVkX1+bJ4sEs1G7Es7an2lJpgjhbuxWGhc/6aw="
        }, {
          "num_cand": "U2FsdGVkX19KDSY83wPH2MKaZUdoja3RIjjJw1oZeJM=",
          "cpf": "U2FsdGVkX1+rInTniMDpK6eSWxDhAgL20b09fg+mIpI="
        }, {
          "num_cand": "U2FsdGVkX187X+O6luWn9l/JH972eygimmqYLA95rNM=",
          "cpf": "U2FsdGVkX19ZFYWV+vWZIrqoJQXPKuInnm3DgSdypew="
        }, {
          "num_cand": "U2FsdGVkX1/Vv+kgrVJ5FR9UnVU/Pl85/uiFBPTvnzo=",
          "cpf": "U2FsdGVkX19j6uvBs5EmiGPNNTq5yKb3fCVSAYQGLLA="
        }, {
          "num_cand": "U2FsdGVkX1/4fxWvIc2gdt1cKuutQdcHnTEhYQb3VQg=",
          "cpf": "U2FsdGVkX1/KPKXlZ5OWD9iVA+a4PTz8XrCEhCkwEsQ="
        }, {
          "num_cand": "U2FsdGVkX1/rhUd55IprB5aLihFpU65Yzc9nvXrjBMo=",
          "cpf": "U2FsdGVkX19x8WmRzBthrQcU5Awc3KdZk8x8doIaOS4="
        }, {
          "num_cand": "U2FsdGVkX19q9CbrQ5ckCDEX7vX9In3gqmI9mSAAbaU=",
          "cpf": "U2FsdGVkX1/7Lmiibf306m1+hSUaBJHccR1JXyAKHsQ="
        }, {
          "num_cand": "U2FsdGVkX18lWhyQHUJNCoTyuMg79hD0yQC7Kg65FVA=",
          "cpf": "U2FsdGVkX1/k8Yy2ztecmRO57/XBT4wjl/jPhPEiFow="
        }, {
          "num_cand": "U2FsdGVkX19QZR1KefHx8KLGeXvgIh/kGYfZeuLPekw=",
          "cpf": "U2FsdGVkX1+xPyPiGBQiodHFM7uKwyjvdO9koMCItJs="
        }, {
          "num_cand": "U2FsdGVkX1+9gHkgTOxwISNfqKAu7mjGSADZhuZxRrk=",
          "cpf": "U2FsdGVkX1+j3ziUYjQrbDHXBva0POnnZrsmOFBchAo="
        }, {
          "num_cand": "U2FsdGVkX1/a4MPfKCQIPJbr/AKG/q0/JtzxD0TkpE8=",
          "cpf": "U2FsdGVkX1/hNcTITKWD4ebN+LQMw87D3OYLq2xMpq8="
        }, {
          "num_cand": "U2FsdGVkX1+lKBUMZfjum7ITIrao0msMNa7JkSnhwyw=",
          "cpf": "U2FsdGVkX1/B/XfLVm74/sBowjlr+Y0lApCpZjKwxhs="
        }, {
          "num_cand": "U2FsdGVkX1/ciLvfC3Y7b1yExdPWdmqrXUZtTKYuLuI=",
          "cpf": "U2FsdGVkX1/0AOrhTvnllCF1uGzhI9xYvhNH514zyVo="
        }, {
          "num_cand": "U2FsdGVkX18jtnrvjVOuhG487GaqNaAzxlUBJEZWtBo=",
          "cpf": "U2FsdGVkX18WNiK18pQlyQBSUaXWFRrvby5PTEhP/Fo="
        }, {
          "num_cand": "U2FsdGVkX18jDeQ3JwcIB/xh/qXq7Sqw1gbublegN6A=",
          "cpf": "U2FsdGVkX180hFIpavJk4Iia4sMq5C0wmDA+j5KPNU0="
        }, {
          "num_cand": "U2FsdGVkX1+2+juPAVCgsOnvi2af2OAHgBk9JR3Iuno=",
          "cpf": "U2FsdGVkX1/iVi96Z/A2VDzBUVGGolcgAmqIiLSJaOc="
        }, {
          "num_cand": "U2FsdGVkX1/YIPzZRY8BrsTgVMjo4/AK5fOwB55wGX0=",
          "cpf": "U2FsdGVkX1/WTGHvmla7N/znuCJKA/DgokM7se+H2ik="
        }, {
          "num_cand": "U2FsdGVkX1949SRMaRq5Rfe2o0J1x61CUT/q45eHY2g=",
          "cpf": "U2FsdGVkX19Sb2fyZLJWDeYX1AyS116ldfl8yXacmk0="
        }, {
          "num_cand": "U2FsdGVkX1+twR44zeqwqGWvBA5wWIFkSkjzHnxjHBI=",
          "cpf": "U2FsdGVkX1/5cvZwgGlkJQmiiF3bz8uRGSQatcmniaE="
        }, {
          "num_cand": "U2FsdGVkX195w0G+pHbEtwB0o94lWfeo6dzm1DeFYu4=",
          "cpf": "U2FsdGVkX1+7yC4B5gzc/ilxlFC55vk9Isfm7Gr5yw4="
        }, {
          "num_cand": "U2FsdGVkX1/Tk7wZG09LS4pgGYUv88fYa3b43HEaXM0=",
          "cpf": "U2FsdGVkX1/Mg1T897Efm7HJQX+g2JhFiWHN91KFI8g="
        }, {
          "num_cand": "U2FsdGVkX1+PUBiWk86KN3pmRQOC/6sc8v50FaTExeo=",
          "cpf": "U2FsdGVkX1/kTxDpIDv3iz9sLoer4cFda9bK/2jsC/0="
        }, {
          "num_cand": "U2FsdGVkX19HkwNG/E2rJTngwK3/JKz4dDqD2mm7wsE=",
          "cpf": "U2FsdGVkX1+5RTFDIvgG/f+zqUKqueYgsel6l+8quLs="
        }, {
          "num_cand": "U2FsdGVkX18C2Kztdho87M0d80vpoQs28IkQPVLdYdw=",
          "cpf": "U2FsdGVkX18/bUVgs8beVEDrIr7hwWwl1MIZXhmtOj0="
        }, {
          "num_cand": "U2FsdGVkX1+s1xLd3zufYHZP6PpBBD/ffBDTyKJVrM0=",
          "cpf": "U2FsdGVkX18aoI3jSez5b933/VQvhWMbb3907g9cb1w="
        }, {
          "num_cand": "U2FsdGVkX1+Xf7moHEm4uQfR5fvML8S3063S3bGLOo0=",
          "cpf": "U2FsdGVkX18aXXV7+tc83GMfp0IOtFGDjol5/5JTBbk="
        }, {
          "num_cand": "U2FsdGVkX1/A3HsXdBVxizHQJ8jAcQEnkV1lQ/vd6t8=",
          "cpf": "U2FsdGVkX19jNjp3yE8DNLqED0Dlayq2ardGq6oHit4="
        }, {
          "num_cand": "U2FsdGVkX1+j78DcJ0X5jQYX7m87jDmKYKZdQBWjbQ0=",
          "cpf": "U2FsdGVkX19Fm/mJby/CiJz2J5fi8XBURUyTkl2q+gY="
        }, {
          "num_cand": "U2FsdGVkX18O8ZwSOq2glO5Pp+a/6zXsh2M0KJ3HsLo=",
          "cpf": "U2FsdGVkX18K4XCF809qf9kIQRd7T3WyeJoFw7TwEdY="
        }, {
          "num_cand": "U2FsdGVkX1+mf0JWPWvcnxg6g3icL7LcCEjXtXbVUjs=",
          "cpf": "U2FsdGVkX1+swM57l5IOvwHge4RhwqyLkjndQxOv+eU="
        }, {
          "num_cand": "U2FsdGVkX180DxehadUGP1uphTJPP8FmFJnSCCOrExo=",
          "cpf": "U2FsdGVkX18B4/5UQBiMvcgm3Qxj6xp4LLnJ+bG2haw="
        }, {
          "num_cand": "U2FsdGVkX1+NVc7wueWD9WP1XJmfJTQjY7SzF2gxFyY=",
          "cpf": "U2FsdGVkX1/y9Cx587cBsSCt0e3yapfD8uvpV5TC/BI="
        }, {
          "num_cand": "U2FsdGVkX19E0NmQ05t+kQYoc+usS8yacH0lGbkJ2yY=",
          "cpf": "U2FsdGVkX1/RqqV5YEHcPeYslpfMWZCO64ijc2DVzS4="
        }, {
          "num_cand": "U2FsdGVkX1/XtXSaFzT7BrvAlhEVmiwyfCSkR6W4LMY=",
          "cpf": "U2FsdGVkX18VSk3qF3pRo8FJp4h7BhBrlpBctekbE6A="
        }, {
          "num_cand": "U2FsdGVkX1+7ZIl6CMDW0E1jIsjseQlu5YRI59fU8Yg=",
          "cpf": "U2FsdGVkX18xzc2GM8gOzf9yUaBQntN2FoIV70hCeT0="
        }, {
          "num_cand": "U2FsdGVkX18EtB9W9DvfhUpO3njEMmOr9GYldSxB4bE=",
          "cpf": "U2FsdGVkX19PRN0RzW2DmVfAlhCC0aayZFvPCWDwxYs="
        }, {
          "num_cand": "U2FsdGVkX19e7lzP0CxZzwXfE/KRT991G8WPYGQNapQ=",
          "cpf": "U2FsdGVkX18ukKJRylfX8mR+eq7loRkExXEa3LrdoTg="
        }, {
          "num_cand": "U2FsdGVkX18gYJe6ta0T25Fa4LAHfdOGpA2fQ1E2oRI=",
          "cpf": "U2FsdGVkX1+ModCEF/jTMte+koBaSitVu7WJ6mMWrVQ="
        }, {
          "num_cand": "U2FsdGVkX1/NtCNOQ9RYndvdaKrs6ruNJ9mXY+8pK8w=",
          "cpf": "U2FsdGVkX1/A7tz7rBhb3SJEPJOqZ6h/kehnNC01Yi4="
        }, {
          "num_cand": "U2FsdGVkX19oqMSfhhsnpBg+hqE5sC8jHfIYvfH0xfg=",
          "cpf": "U2FsdGVkX1/FDBJuslXK9JxxT2M1wonOJqYTz7d4tCM="
        }, {
          "num_cand": "U2FsdGVkX18WxSOj0NPn7mkC2b8mdhyFwYrKJ+Zl8wc=",
          "cpf": "U2FsdGVkX1+zDy3OC6uc+qvoYK4Qwr67ISUGpFLqAYc="
        }, {
          "num_cand": "U2FsdGVkX1+kO2O8+6zCChGE928L1PxdhsKjMq0k1L8=",
          "cpf": "U2FsdGVkX19YIpEvCELHXyPD2ZZv9q54bwuqvMM7WsQ="
        }, {
          "num_cand": "U2FsdGVkX18do9mLYmt1C0U6wUDCzjJKjAr3UGnMbd4=",
          "cpf": "U2FsdGVkX19QDNZuGzs5W3wxDX6YOGAbYlTxjHxGeU4="
        }, {
          "num_cand": "U2FsdGVkX19Xciql5TLi34BBaUMAapzJTmLabqQxX8o=",
          "cpf": "U2FsdGVkX1+rEjs10n9dRbjo808V+sqCkOwK94IdnzE="
        }, {
          "num_cand": "U2FsdGVkX1/Ab1HjwMi2QgEnx2lt8GZ1tTXRnElhWHo=",
          "cpf": "U2FsdGVkX19TEK5/EHL44SQ7zx5ZcDgikR07xzYj+oQ="
        }, {
          "num_cand": "U2FsdGVkX1+hYL3Ofvz/Gm6nI02inZPgDzjoPWiWQtY=",
          "cpf": "U2FsdGVkX1+6kLXyRUNWV+gSi9xsGtFuz2CE/FdK19Y="
        }, {
          "num_cand": "U2FsdGVkX18XyGAiE4U15kVewJ5n0KI3xGJ9938yJFY=",
          "cpf": "U2FsdGVkX18u/A0OtZ8Iw5Legu/ddvCv2kTa1rv08Qg="
        }, {
          "num_cand": "U2FsdGVkX19anSpmNkp2YZPJYOUigHZft0CUh+i+/uU=",
          "cpf": "U2FsdGVkX1/cDoBtPMzim9gTP+82xSlvNIXj7ioiL1E="
        }, {
          "num_cand": "U2FsdGVkX18tj+g5znnKp2AgjRhEdsiHNGBAyB88LK4=",
          "cpf": "U2FsdGVkX1+QCGDe+w6ZnKJ4ATvcToVdBeUhaPevxeQ="
        }, {
          "num_cand": "U2FsdGVkX1844qMEC2NwYpcdb61tOntjTZU+HwGU9Cc=",
          "cpf": "U2FsdGVkX18EjwmO2A/YVPTbechuGzX+JW7Yv7F/QRc="
        }, {
          "num_cand": "U2FsdGVkX19x8GW+th4FS3ASZXf+Nn2v6gKoLlZsT1c=",
          "cpf": "U2FsdGVkX19nr8FzqDCYFjk8mbW0mAm5aMQ7HL0gdkE="
        }, {
          "num_cand": "U2FsdGVkX19hLpGUmVAPTiNRfu+VcqJQnfg84zMRlSo=",
          "cpf": "U2FsdGVkX1+WAD7dngsoYDmdg6sNgn86HzKLuEQlL4U="
        }, {
          "num_cand": "U2FsdGVkX18+ydKx8Qh6o3tnNIZu3hSUronwTsjOqwc=",
          "cpf": "U2FsdGVkX1/JsjhJGEYlD28DFrNEc134JJOemiN85Zk="
        }, {
          "num_cand": "U2FsdGVkX1/OgWUaW9VkXdASjWjssacdG8hSuod4JXc=",
          "cpf": "U2FsdGVkX1+2dFrwJQHKlp2/LT7mrcnirWmah68QuS0="
        }, {
          "num_cand": "U2FsdGVkX18Cr8B9hTvQi9BgBR+V1Aib2K2S3nwcjMk=",
          "cpf": "U2FsdGVkX18o2s1IKPA0YhDF1ka0djCYNmMR08sE4es="
        }, {
          "num_cand": "U2FsdGVkX19qU5Q67VTQVLwS6Ql+T9KZV5DyvHi1Ql0=",
          "cpf": "U2FsdGVkX1/ww+cA2fBzmocstzuM5nDPN9MSS+ZohjE="
        }, {
          "num_cand": "U2FsdGVkX18LdWTFTkgpdPCiV1nz3kdooOYcJinxWAA=",
          "cpf": "U2FsdGVkX1+rGJApjZ6qYkbSoZbMYAH0wBFivyWm7R4="
        }, {
          "num_cand": "U2FsdGVkX18teqAs+tN+5ZBy3VAuS2mEAN7GueFJEKI=",
          "cpf": "U2FsdGVkX1/BAVyW/04mtyU6wX5I8RAqzMle9ue884k="
        }, {
          "num_cand": "U2FsdGVkX1+oHtVGAVIfbx6D9UlS4hMpf+g2A/rLA4A=",
          "cpf": "U2FsdGVkX1/9j9ymtM8d/N3cNzT6YM9MVs/33dQy7Lg="
        }, {
          "num_cand": "U2FsdGVkX18fG+hkW3GOBaeOWJZJ9pZvk5tq3cBhyh4=",
          "cpf": "U2FsdGVkX1+MDfEL/UDNR4AFRyvLpQuBGN8USy7LnTg="
        }, {
          "num_cand": "U2FsdGVkX1+byzK8MfLx0rG1TwYUF3nAuTC3n/TkYTs=",
          "cpf": "U2FsdGVkX19pUtjEKgLlC5pB1E3RVrCP6uleE2fbqLg="
        }, {
          "num_cand": "U2FsdGVkX18cZ2552RxWLWHZELpSZU8kqBZUtqpBhb4=",
          "cpf": "U2FsdGVkX1+DBrCMiZFk6qOCbljgDSo/2UrPyQiPcAY="
        }, {
          "num_cand": "U2FsdGVkX1+BB+rEsaiabcsU4fuQwN++LYnpE/rX8VU=",
          "cpf": "U2FsdGVkX1+SJqEqXZkYut2EAl4iJUbxbmHlooU40tc="
        }, {
          "num_cand": "U2FsdGVkX1/Ih5pKnKbmDyW67mMeL3ZmEp32scFToMY=",
          "cpf": "U2FsdGVkX1+ByuXcNRUFNKBVxurLBs3N9w045RPr75w="
        }, {
          "num_cand": "U2FsdGVkX19fDbk3HYZPvLpoBV8a7hrLtqrv2tWP7oU=",
          "cpf": "U2FsdGVkX1+6TT4XGmnSTZ3ZQtttvpFaxCWtFer9ukE="
        }, {
          "num_cand": "U2FsdGVkX1/tQh/gAzyWtGbUcFRHziWp653m9lyADSI=",
          "cpf": "U2FsdGVkX18S4Vs+2r1ioy/YT1sTYfep0M1d+GvzJZ4="
        }, {
          "num_cand": "U2FsdGVkX18UIKOrrVnKSGjNdUH1KEEHZouauNm2aSs=",
          "cpf": "U2FsdGVkX18wW+Ro4EAIIMuSJ9uPM7Veu926v7wnx/Y="
        }, {
          "num_cand": "U2FsdGVkX1+nG4uTDsPHyRaiaw2zSvH7ztdVLlsF8yM=",
          "cpf": "U2FsdGVkX19KNjWYpYzaxcZC6fpO7seDhkfHchZjI1A="
        }, {
          "num_cand": "U2FsdGVkX18XeEICcTMwevDl+ukQOttN4i2Rim1JvHA=",
          "cpf": "U2FsdGVkX19PJ4RrS9J+lDq1ka4kXiR+OJAN3pVcYJI="
        }, {
          "num_cand": "U2FsdGVkX186LsGQcd7wJccJJtvucPEH4BaPBLsbFx8=",
          "cpf": "U2FsdGVkX18mrEaiU5irWXScdfQMUIIazHUF2rEkS7k="
        }, {
          "num_cand": "U2FsdGVkX1/CbHcZBrwoIJrKrIwETn0b29ZwPUZ4REM=",
          "cpf": "U2FsdGVkX1+TUX7MgoHr6KVeVCzoq+hLFnX01VVlw5Q="
        }, {
          "num_cand": "U2FsdGVkX18k34aZdbCAXYQ0GR1fGZjAOrgHXDQtXv0=",
          "cpf": "U2FsdGVkX1/+Rwz3EAz1KA77B2fvlqIZO17IQOolDgc="
        }, {
          "num_cand": "U2FsdGVkX1/6T5cmGMQF5MiG/eXXK6P0ByjnBC7kZAs=",
          "cpf": "U2FsdGVkX1+SzpxA+mRoRZgEhMWgGh5A+SlNpUxsSh4="
        }, {
          "num_cand": "U2FsdGVkX1+pXvecp6k4/eT+QfLFktsOGkUiGN/+NlQ=",
          "cpf": "U2FsdGVkX1+ybol8qTQP2BW5qMbllsfkkqYLUP2q+Ac="
        }, {
          "num_cand": "U2FsdGVkX19nUb8Q4JImdNrtOOZRIXr+585sRiXAZgE=",
          "cpf": "U2FsdGVkX1/xdGpaZ7/W8uPC/nnX1uPJycqX0x44Tco="
        }, {
          "num_cand": "U2FsdGVkX18LSOyErpc0MSG0muMD7c8vs3KlQSfWnek=",
          "cpf": "U2FsdGVkX1+6/3ecntj2Yz4E/rDMP5IcyePk1sgRoT8="
        }, {
          "num_cand": "U2FsdGVkX1+rcPEYBwo91JHff8sNhX0ce0H1C2ITNAs=",
          "cpf": "U2FsdGVkX1/Bpwy3DLvCmxyHQ7RUmMcqNkTPT2ByQws="
        }, {
          "num_cand": "U2FsdGVkX18DplzqXOMBSi/JFRaia+eE+bWuYTBrikM=",
          "cpf": "U2FsdGVkX1+Q3GmFyhmb+GDpXO25OrbmXarDZpqXgvU="
        }, {
          "num_cand": "U2FsdGVkX1+j+IPDsqA2k5hlbJ8tJMj1UBHtLOq8HDo=",
          "cpf": "U2FsdGVkX1+4zLqUyuTDPfX7950KHqaIKi3vzia72+A="
        }, {
          "num_cand": "U2FsdGVkX1+4hUYxE3NegT363X7I4W8Ser82LSUlT2A=",
          "cpf": "U2FsdGVkX19eXTebTq3+1n8X4+H0axusf99a6Z93v0A="
        }, {
          "num_cand": "U2FsdGVkX1/b44vf5F7l/IUzyli6UxcopypcHuiQV34=",
          "cpf": "U2FsdGVkX1+MhAADk+eANUNDhryN+VOS3EFb3qvDyRs="
        }, {
          "num_cand": "U2FsdGVkX19YHl0KL0xW6HFbTyCpBusJqJ8s638yH3M=",
          "cpf": "U2FsdGVkX1+RdEAmUAJUBwadjeX1byRpNCzC5kGZ7tE="
        }, {
          "num_cand": "U2FsdGVkX1/fYnSjWUy6j/HUTHQjL8z1VTXK0PwFHn0=",
          "cpf": "U2FsdGVkX19JTl3FIdK6CuZONiAEzP2jG4dAnoEGd0E="
        }, {
          "num_cand": "U2FsdGVkX18kizPW6+31KH8lRXmBXZuKUleG7Yka3dg=",
          "cpf": "U2FsdGVkX1/7HwnLNu0R9Y2GF1fCUHkyw9edj3wJlpM="
        }, {
          "num_cand": "U2FsdGVkX1+RQgjKjLtOm5gS/sVIhhyuR+WqgdwImig=",
          "cpf": "U2FsdGVkX1/CjRX94EkmrzuqWPOrMw4MJTWNSVa8DdA="
        }, {
          "num_cand": "U2FsdGVkX1+cyOAk8/e0koQcGiIcll6XLvONplIWynI=",
          "cpf": "U2FsdGVkX1+BK2+GCGtDUsdfcAGFPkNqsBrNzV3UIro="
        }, {
          "num_cand": "U2FsdGVkX1/rwXCP8QpBZ/TY4wp/kto4plk4ep5qgYc=",
          "cpf": "U2FsdGVkX18szSu8P4uTTR6ZBlcR8VHEHbqtso8woI4="
        }, {
          "num_cand": "U2FsdGVkX18eQ0nqFyl816lpjcNanmLK1RSlx1S3loc=",
          "cpf": "U2FsdGVkX180aZbHTKHKr8R7kPmcIJpBZAz88VJisRA="
        }, {
          "num_cand": "U2FsdGVkX1+DEbdxzulYKGPS5tQOgGWyhrHCC7UA144=",
          "cpf": "U2FsdGVkX1+vyWc98vCrXQ2UTVXyFWgn2g5dYDDRzxY="
        }, {
          "num_cand": "U2FsdGVkX1+hMc9MoJmVyrYm4qh99o4Mx7Yhw0UzDc4=",
          "cpf": "U2FsdGVkX1+x/a6ueIbkmsWrAG2cUPwoUBniLqBbrvs="
        }, {
          "num_cand": "U2FsdGVkX1+r3t3tPezuph+6XBVuUhMUiNvmHeKwu/w=",
          "cpf": "U2FsdGVkX19ptH6Rq1zdN/gl92RBZtw3eQN5FDg2PYk="
        }, {
          "num_cand": "U2FsdGVkX1/5feA4I6orDSc7NVueh6TGiuCcVVGw8AE=",
          "cpf": "U2FsdGVkX18woP2GFy7iRkmrBVJZltt+phEE7Jazzbg="
        }, {
          "num_cand": "U2FsdGVkX1/62ptlrd85JYb036e984AamPk5XSg7NOM=",
          "cpf": "U2FsdGVkX18XzdrbQRrYON3uQcA/52ho9RTkCGVfjdI="
        }, {
          "num_cand": "U2FsdGVkX18sX3aRleMmkuM3VISmwnHCTBi7QkA7uow=",
          "cpf": "U2FsdGVkX1+KZD6CthPzk0pKoy+qfFPkTrN22T6E9uw="
        }, {
          "num_cand": "U2FsdGVkX193wzhmkc1yW7Ak+fVz8rnE19q+PusCRAU=",
          "cpf": "U2FsdGVkX185XLz1e7yf8pC+hs5WEsUH5t4pn9Gz0uc="
        }, {
          "num_cand": "U2FsdGVkX19AlXGLcDo8sHq/eTvgixYgHazP4k4xyak=",
          "cpf": "U2FsdGVkX19j94lmFAw3vD+Bq8Yb2HX42iA2E1c+JSE="
        }, {
          "num_cand": "U2FsdGVkX19CjsmtGM9WLEbLDfiZS8r+Mb0palLgRBE=",
          "cpf": "U2FsdGVkX19hj2Rzt3X4DyAof4vrRyVH0NXy9+AZ3gk="
        }, {
          "num_cand": "U2FsdGVkX19B6qxrUtQwr+92TarFbmgW07Db3IP3ApM=",
          "cpf": "U2FsdGVkX1+ezllTzPFmB/Ve7m8Qw991ZjihsHEEerQ="
        }, {
          "num_cand": "U2FsdGVkX19xGnQ0f0QugYoZ/5WwWYbJCL68J6jCl8w=",
          "cpf": "U2FsdGVkX1/9ZvP1PnhuJLHM53+lo6Ada+o3HBTqsUY="
        }, {
          "num_cand": "U2FsdGVkX19+Q8xC8k9qQpC6TWThcB8LR3E86YTJRNo=",
          "cpf": "U2FsdGVkX1+ZDLiwT3kqaUuoNaT+JKvBM7ncOegBChc="
        }, {
          "num_cand": "U2FsdGVkX19u8zrM2+1V99K5/rKocuUy1YoWIHROLdQ=",
          "cpf": "U2FsdGVkX1/ieye7zURIC4/BJFkYJ/3yV1H4qij+46Q="
        }, {
          "num_cand": "U2FsdGVkX19fDDAhI85wOXx/xkl8dj/aOCyUD1hnE9I=",
          "cpf": "U2FsdGVkX18yHO0j+1NIfl+g6omzU2S8uZtq83d9FqI="
        }, {
          "num_cand": "U2FsdGVkX1/jHKowROiqrpVie0gxt7QFO7uQ5szD51U=",
          "cpf": "U2FsdGVkX19ZfuGKEUIFnrlMvegpaNxu+DpVu0Gv1es="
        }, {
          "num_cand": "U2FsdGVkX18py5jtxagI+4XwBOrdhDO+wrqLi6ZUHgQ=",
          "cpf": "U2FsdGVkX1/hnCe7RhNCh8bc6BIHsURU5PzM9DKSszs="
        }, {
          "num_cand": "U2FsdGVkX1/L46f9w4YL04SMqKwO5mbImglegUZh98g=",
          "cpf": "U2FsdGVkX1/+VjQJVEjS1uiY6TL1Rd6JHpMQgBsc0gI="
        }, {
          "num_cand": "U2FsdGVkX19GUOwTp9ltCZIUBNkosSU168is48HGOwk=",
          "cpf": "U2FsdGVkX18aRq0mNGRODHOHtuCgiO7mruQzwQHCTDM="
        }, {
          "num_cand": "U2FsdGVkX19wZ9UMXvafBqvWU2r9OPD8MIhlrgWHf4E=",
          "cpf": "U2FsdGVkX1/NLsSLzuaC8XYsSyMCkSJ/AriWgevDPHo="
        }, {
          "num_cand": "U2FsdGVkX1+RRvnXeIWmnPTMKfbzvc0EOyZDjeet+nQ=",
          "cpf": "U2FsdGVkX1/wlJY7iBaDPHGGsGv1C4IeaifME6n7fts="
        }, {
          "num_cand": "U2FsdGVkX181PjU8kBzUtuNQaiOjyn4H/Q4iI3nvSzw=",
          "cpf": "U2FsdGVkX1+cpf431/ShGZm+qlbPMfyJRsw/8dakAns="
        }, {
          "num_cand": "U2FsdGVkX1+1PVVmn7syjlVvslGHZokkOYNZkaGTNVw=",
          "cpf": "U2FsdGVkX18cmmq89aBlK4T5Dxy9/7bLHj65zLHlEms="
        }, {
          "num_cand": "U2FsdGVkX18i3EjosMvebCDKXPMSLXKplQ51jRVIACE=",
          "cpf": "U2FsdGVkX18gHxKW46gv2W5xXic4gm2gDVATZafIKmw="
        }, {
          "num_cand": "U2FsdGVkX18v3p8AI85K624liOuC3wpTS38jx+//gHY=",
          "cpf": "U2FsdGVkX1+PPf1h1y6Sxaa52ruRsD9Dd+iUZTqKRUg="
        }, {
          "num_cand": "U2FsdGVkX1/K3hGtKJcvVA1OUO91gX9G0OZE/b8QI1U=",
          "cpf": "U2FsdGVkX19MQDZDk3ATLgbNgZt4UfGSmKO4fI6xB2w="
        }, {
          "num_cand": "U2FsdGVkX18vgxlpqNsfTFROE8o5vjGJJCJSnLjIWi4=",
          "cpf": "U2FsdGVkX1801bzx76IdMEo/4Yfm05MhiDX/MRbKhO8="
        }, {
          "num_cand": "U2FsdGVkX18brFXpdMBCnCxT+j9b2FqLJSesLOMt24U=",
          "cpf": "U2FsdGVkX198Fvc/N8wogE+/V1NEmBXNsGCy8NiNCrc="
        }, {
          "num_cand": "U2FsdGVkX18Mj+A54q259/VDUeTt9SvifVyRtdXkq+4=",
          "cpf": "U2FsdGVkX1+6iQNm14OSK0kbHhnhKlCKwfIYYQO3P84="
        }, {
          "num_cand": "U2FsdGVkX19Ns/2JSTzVRLi0aisOHm1YX0yFNTmsz7c=",
          "cpf": "U2FsdGVkX1+XDau6jvFW02zJcPSiu444/wwJ29D6jy8="
        }, {
          "num_cand": "U2FsdGVkX1+CXDb+rTpB6sJA3d5MUnDAb7Lk3p5iCKw=",
          "cpf": "U2FsdGVkX1971tMrzoGSGCSB96TBxGDqXsEOMcGgVhA="
        }, {
          "num_cand": "U2FsdGVkX18pNMdbvXySwad7A1iMOU+tNWzJt6MQNeQ=",
          "cpf": "U2FsdGVkX19TTYlXSSxlyinolrt9tqV62IsPSOM8eOw="
        }, {
          "num_cand": "U2FsdGVkX18CNaQEaY300TGsmV6kUCIPPvwlJM0uJws=",
          "cpf": "U2FsdGVkX1+mOfCZMzIP3FJX0r6lci4bjpoIQLHenDc="
        }, {
          "num_cand": "U2FsdGVkX19Uaaw76ZJohROCaRtHjkCIizOZ+ykvHbE=",
          "cpf": "U2FsdGVkX1/i6JWzms/4HybzunLQTjyxTEgbycVgGUc="
        }, {
          "num_cand": "U2FsdGVkX1/3u4LIIgsaP6rtYVAPkBdzyHht4V7mHAY=",
          "cpf": "U2FsdGVkX1/aZxVvK6mXZ7L8LCFl9MweY1QAemHeaO4="
        }, {
          "num_cand": "U2FsdGVkX18W7zakEqvQS8nuhKJ8qkcEGnl7sYK3DPQ=",
          "cpf": "U2FsdGVkX19sYl2hCVRYJkwzdimTHGQkhzYMu/AwZNs="
        }, {
          "num_cand": "U2FsdGVkX1+DZKPI+605tIG9+ZsUW706dACs9a19j+E=",
          "cpf": "U2FsdGVkX1+z5gyWqvQh0gTBiDOcdQ5gJ0dS2Xk6wrQ="
        }, {
          "num_cand": "U2FsdGVkX18dhOkKSelwuSxjfvvVal9g2acJa2PBNt8=",
          "cpf": "U2FsdGVkX18qnMAb1VIu8/lstHSvbaNGXHZvzHjLNbw="
        }, {
          "num_cand": "U2FsdGVkX18KXyODCWNm6Ca2OGK1/b5Z6GuCnm8Spzw=",
          "cpf": "U2FsdGVkX19cYsCe+xrRRHPDLY6uAOAoBgDHhvNBm+k="
        }, {
          "num_cand": "U2FsdGVkX18rl700Fm/0KeU79y+pAQdRcZaN54EFpH4=",
          "cpf": "U2FsdGVkX19tIGZxnkU75oGjmwD9LF/D/38zWiJxiO8="
        }, {
          "num_cand": "U2FsdGVkX1+hKvUPL0j0bSG9ArLyvIu4VO0i7sHjPfA=",
          "cpf": "U2FsdGVkX19O6PN0os0amNjsVNmM6ltaVO3mjjh0P/w="
        }, {
          "num_cand": "U2FsdGVkX18bUgtnkJE/17rbAdtYn6f1Z6Yc1Xrf6yE=",
          "cpf": "U2FsdGVkX18fql8/WMdQIzbLaEIRnveV5sbn9wFHvdg="
        }, {
          "num_cand": "U2FsdGVkX18hmWMyqLXlGLyn4h/yZ1UfG6LE5oR4Y+4=",
          "cpf": "U2FsdGVkX1/7jJrcNZzDVtkO1ObHRmAyKwsGhCdcqXA="
        }, {
          "num_cand": "U2FsdGVkX19A2fvkLM66yYnPDMz2CHZqRFaSNnuTiVs=",
          "cpf": "U2FsdGVkX18u5iqaWqCmY9geBglpZ2d8/rrAZzuGCak="
        }, {
          "num_cand": "U2FsdGVkX193qATwyd8jSdZwrBeKBl5RrqYxInfh4dE=",
          "cpf": "U2FsdGVkX19Ws4sjsEXVrLax2H7/OhGIPe/GqmlTmqY="
        }, {
          "num_cand": "U2FsdGVkX19To3Oz71Hx4vW7hvHyt6BRL4/0+UUJgvc=",
          "cpf": "U2FsdGVkX1+JVdlKcbl7KVGvpFa8tCTLTscTV/yscSA="
        }, {
          "num_cand": "U2FsdGVkX1+vmk6T2sQXj5io9LpSooxWAy2WXkA6pDM=",
          "cpf": "U2FsdGVkX19InHx30kL7J5jlR/SyYBoLEgwAa4JY+Ao="
        }, {
          "num_cand": "U2FsdGVkX199P1vm2vJl+tEBNjZWBKEu4pkjJFVTkoU=",
          "cpf": "U2FsdGVkX19AgDdsGu5L4zzdOE2f7Ad91X3H4FEJ4Ig="
        }, {
          "num_cand": "U2FsdGVkX1/zb2HU+tJkY1YHaiSs9LsweHSOnYrGZKg=",
          "cpf": "U2FsdGVkX1+HJyDbjAMDmyaMkSIRIkPRW5/ewTB4JXQ="
        }, {
          "num_cand": "U2FsdGVkX18AzD5NMMJGjqM9x1VNWc3OHFsC+hOqht4=",
          "cpf": "U2FsdGVkX1/ZKG2WNA/fGypLD5AjpLpMeJPuSwGgzdM="
        }, {
          "num_cand": "U2FsdGVkX1+ZaGKDkCDKjDLOcVOwRmAwtSsWW6OlIDg=",
          "cpf": "U2FsdGVkX19pW2l5Ri/0mgjIO73hAlWPKNYwXtr64wM="
        }, {
          "num_cand": "U2FsdGVkX1+TjwpfdJCAec4IxHQpcHGOIZpulOsksWA=",
          "cpf": "U2FsdGVkX1+F4L5X3VU6Va84fW4F+giRZ8tupp7QZC0="
        }, {
          "num_cand": "U2FsdGVkX1834DmbR0bxmiVlTYd4XT+Ao+o9SvKvF1U=",
          "cpf": "U2FsdGVkX19qxDv8oo4E5Jaliw7f3SXsBltBn5AuoFo="
        }, {
          "num_cand": "U2FsdGVkX1+4f1pws1cwv3cBcTmvA5fu+OtF8lAwqGo=",
          "cpf": "U2FsdGVkX1+awSIOyZpeGMy5aoBtGzespwIz5BgvAis="
        }, {
          "num_cand": "U2FsdGVkX19UloeB7dWv159y/qmsCtUU2LIVBzmDvx0=",
          "cpf": "U2FsdGVkX18vKu6CeD8q2T+ZHHP2YfgbpDl+I+1u+3o="
        }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2204/2204_re_gabsx/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
